






// // // import { useCallback, useEffect, useState } from "react";

// // // /* =====================================================
// // //    API  (backend: /api/palaces + /api/palace-room-categories)
// // // ===================================================== */

// // // const API_BASE = process.env.REACT_APP_API_URL || "https://bmtvendorvendorfinal.onrender.com";
// // // const PALACE_API = `${API_BASE}/api/palaces`;
// // // const ROOM_API = `${API_BASE}/api/palace-room-categories`;

// // // async function request(url, options = {}) {
// // //   const token = localStorage.getItem("vendorToken");

// // //   if (!token) {
// // //     window.location.href = "/vendor-login";
// // //     throw new Error("Session expired. Please login again.");
// // //   }

// // //   const response = await fetch(url, {
// // //     ...options,
// // //     headers: { Authorization: `Bearer ${token}`, ...(options.headers || {}) },
// // //   });

// // //   const data = await response.json().catch(() => ({}));

// // //   if (response.status === 401) {
// // //     localStorage.removeItem("vendorToken");
// // //     localStorage.removeItem("vendorUser");
// // //     window.location.href = "/vendor-login";
// // //     throw new Error("Session expired. Please login again.");
// // //   }

// // //   if (!response.ok || data.success === false) {
// // //     throw new Error(data.message || `Request failed (${response.status})`);
// // //   }

// // //   return data;
// // // }

// // // /* =====================================================
// // //    OPTIONS / DEFAULTS  (same enums as palaceRoomCategoryModel.js)
// // // ===================================================== */

// // // const ROOM_TYPES = [
// // //   ["DELUXE", "Deluxe"],
// // //   ["PREMIUM", "Premium"],
// // //   ["ROYAL", "Royal"],
// // //   ["HERITAGE", "Heritage"],
// // //   ["SUITE", "Suite"],
// // //   ["MAHARAJA_SUITE", "Maharaja Suite"],
// // //   ["VILLA", "Villa"],
// // //   ["OTHER", "Other"],
// // // ];

// // // const AMENITY_OPTIONS = [
// // //   "Air Conditioning", "Free Wi-Fi", "TV", "Mini Bar", "Tea / Coffee Maker",
// // //   "Private Balcony", "Bathtub", "Attached Bathroom", "Safe / Locker", "Hair Dryer",
// // //   "Work Desk", "Heating", "Garden View", "Palace View", "Pool View",
// // //   "Room Service", "Butler Service",
// // // ];

// // // const MAX_IMAGES = 15;
// // // const MAX_IMAGE_MB = 10;

// // // const EMPTY_FORM = {
// // //   name: "",
// // //   description: "",
// // //   roomType: "DELUXE",
// // //   roomSize: "0",
// // //   roomSizeUnit: "SQFT",
// // //   bedType: "",
// // //   bedCount: "1",
// // //   totalUnits: "1",
// // //   includedAdults: "2",
// // //   maxAdults: "2",
// // //   maxChildren: "0",
// // //   maxGuests: "2",
// // //   extraMattressAllowed: false,
// // //   maxExtraMattress: "0",
// // //   amenities: [],
// // // };

// // // const str = (v) => (v === undefined || v === null ? "" : String(v));

// // // function formFromRoom(r) {
// // //   return {
// // //     name: str(r.name),
// // //     description: str(r.description),
// // //     roomType: r.roomType || "DELUXE",
// // //     roomSize: str(r.roomSize ?? 0),
// // //     roomSizeUnit: r.roomSizeUnit || "SQFT",
// // //     bedType: str(r.bedType),
// // //     bedCount: str(r.bedCount ?? 1),
// // //     totalUnits: str(r.totalUnits ?? 1),
// // //     includedAdults: str(r.includedAdults ?? 2),
// // //     maxAdults: str(r.maxAdults ?? 2),
// // //     maxChildren: str(r.maxChildren ?? 0),
// // //     maxGuests: str(r.maxGuests ?? 2),
// // //     extraMattressAllowed: Boolean(r.extraMattressAllowed),
// // //     maxExtraMattress: str(r.maxExtraMattress ?? 0),
// // //     amenities: Array.isArray(r.amenities) ? r.amenities : [],
// // //   };
// // // }

// // // /* =====================================================
// // //    VALIDATION  (same rules as palaceRoomCategoryController.js)
// // // ===================================================== */

// // // function validateForm(f) {
// // //   if (!f.name.trim()) return "Room category name is required.";
// // //   if (f.name.trim().length > 120) return "Name cannot exceed 120 characters.";

// // //   const n = (v) => Number(v === "" ? NaN : v);

// // //   const roomSize = n(f.roomSize);
// // //   if (!Number.isFinite(roomSize) || roomSize < 0) return "Room size must be 0 or more.";

// // //   const bedCount = n(f.bedCount);
// // //   if (!Number.isInteger(bedCount) || bedCount < 1) return "Bed count must be a whole number, at least 1.";

// // //   const totalUnits = n(f.totalUnits);
// // //   if (!Number.isInteger(totalUnits) || totalUnits < 1) return "Total units must be a whole number, at least 1.";

// // //   const includedAdults = n(f.includedAdults);
// // //   const maxAdults = n(f.maxAdults);
// // //   const maxChildren = n(f.maxChildren);
// // //   const maxGuests = n(f.maxGuests);
// // //   const maxExtraMattress = n(f.maxExtraMattress);

// // //   if (!Number.isInteger(includedAdults) || includedAdults < 1) return "Included adults must be at least 1.";
// // //   if (!Number.isInteger(maxAdults) || maxAdults < 1) return "Max adults must be at least 1.";
// // //   if (!Number.isInteger(maxChildren) || maxChildren < 0) return "Max children must be 0 or more.";
// // //   if (!Number.isInteger(maxGuests) || maxGuests < 1) return "Max guests must be at least 1.";
// // //   if (!Number.isInteger(maxExtraMattress) || maxExtraMattress < 0) return "Max extra mattress must be 0 or more.";

// // //   if (includedAdults > maxAdults) return "Included adults cannot exceed maximum adults.";
// // //   if (maxGuests < includedAdults) return "Maximum guests cannot be less than included adults.";
// // //   if (maxGuests < maxAdults + maxChildren) return "Maximum guests cannot be less than max adults plus max children.";

// // //   if (f.extraMattressAllowed && maxExtraMattress < 1) {
// // //     return "Set max extra mattress to 1 or more, or turn off extra mattress.";
// // //   }

// // //   const lower = f.amenities.map((a) => a.trim().toLowerCase());
// // //   if (lower.some((a) => !a) || new Set(lower).size !== lower.length) {
// // //     return "Amenities cannot be empty or duplicated.";
// // //   }

// // //   return "";
// // // }

// // // /* =====================================================
// // //    STYLES (scoped with "rc-" prefix)
// // // ===================================================== */

// // // const css = `
// // // .rc-wrap{font-family:'Inter','Segoe UI',Arial,sans-serif;color:#0f172a}
// // // .rc-head{display:flex;justify-content:space-between;align-items:flex-start;gap:16px;flex-wrap:wrap;margin-bottom:22px}
// // // .rc-head h2{margin:0 0 4px;font-size:26px;letter-spacing:-.5px}
// // // .rc-head p{margin:0;color:#64748b;font-size:14px}
// // // .rc-btn{border:0;border-radius:10px;padding:10px 18px;font-size:13px;font-weight:700;cursor:pointer;transition:.15s}
// // // .rc-btn:disabled{opacity:.6;cursor:not-allowed}
// // // .rc-primary{background:linear-gradient(135deg,#f97316,#ea580c);color:#fff}
// // // .rc-ghost{background:#fff;border:1px solid #cbd5e1;color:#0f172a}
// // // .rc-danger{background:#fff;border:1px solid #fecaca;color:#b91c1c}
// // // .rc-small{padding:7px 12px;font-size:12px}
// // // .rc-alert{padding:12px 14px;border-radius:10px;margin-bottom:16px;font-size:13px}
// // // .rc-err{background:#fff7ed;border:1px solid #fed7aa;color:#9a3412}
// // // .rc-ok{background:#f0fdf4;border:1px solid #bbf7d0;color:#166534}
// // // .rc-picker{background:#fff;border:1px solid #e2e8f0;border-radius:16px;padding:16px 20px;margin-bottom:20px;display:flex;align-items:center;gap:14px;flex-wrap:wrap}
// // // .rc-picker label{font-size:12px;font-weight:700;color:#374151}
// // // .rc-picker select{flex:1;min-width:220px;border:1px solid #cbd5e1;border-radius:10px;padding:10px 12px;font-size:14px;background:#fff;color:#0f172a}
// // // .rc-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));gap:18px}
// // // .rc-card{background:#fff;border:1px solid #e2e8f0;border-radius:16px;overflow:hidden;display:flex;flex-direction:column}
// // // .rc-cover{height:170px;background:#f1f5f9;display:grid;place-items:center;color:#94a3b8;font-size:13px;position:relative}
// // // .rc-cover img{width:100%;height:100%;object-fit:cover;display:block}
// // // .rc-badge{position:absolute;top:10px;left:10px;padding:4px 10px;border-radius:999px;font-size:11px;font-weight:800}
// // // .rc-body{padding:16px;display:flex;flex-direction:column;gap:6px;flex:1}
// // // .rc-body h3{margin:0;font-size:17px}
// // // .rc-meta{font-size:12px;color:#64748b}
// // // .rc-actions{display:flex;gap:8px;flex-wrap:wrap;margin-top:auto;padding-top:12px}
// // // .rc-empty{background:#fff;border:1px dashed #cbd5e1;border-radius:16px;padding:48px 20px;text-align:center;color:#64748b}
// // // .rc-form{display:flex;flex-direction:column;gap:18px}\n.rc-stepper{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:8px;background:#fff;border:1px solid #e2e8f0;border-radius:14px;padding:14px}\n.rc-step{display:flex;align-items:center;gap:8px;color:#94a3b8;font-size:12px;min-width:0}\n.rc-step span{display:grid;place-items:center;flex:0 0 28px;height:28px;border-radius:50%;background:#f1f5f9;font-weight:800}\n.rc-step small{font-size:11px;line-height:1.3}\n.rc-step.active{color:#c2410c;font-weight:800}\n.rc-step.active span,.rc-step.done span{background:#ea580c;color:#fff}\n.rc-step.done{color:#475569}\n@media(max-width:700px){.rc-stepper{grid-template-columns:1fr 1fr}.rc-step small{font-size:10px}}
// // // .rc-section{background:#fff;border:1px solid #e2e8f0;border-radius:16px;padding:20px}
// // // .rc-section h3{margin:0 0 14px;font-size:16px}
// // // .rc-fields{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px}
// // // .rc-field{display:flex;flex-direction:column;gap:6px}
// // // .rc-field.full{grid-column:1/-1}
// // // .rc-field label{font-size:12px;font-weight:700;color:#374151}
// // // .rc-field input,.rc-field select,.rc-field textarea{border:1px solid #cbd5e1;border-radius:10px;padding:10px 12px;font-size:14px;font-family:inherit;color:#0f172a;background:#fff;outline:none;width:100%;box-sizing:border-box}
// // // .rc-field input:focus,.rc-field select:focus,.rc-field textarea:focus{border-color:#ea580c}
// // // .rc-hint{font-size:11px;color:#94a3b8}
// // // .rc-count{font-size:11px;color:#94a3b8;text-align:right}
// // // .rc-chips{display:flex;flex-wrap:wrap;gap:8px}
// // // .rc-chip{display:inline-flex;align-items:center;gap:6px;padding:7px 12px;border:1px solid #cbd5e1;border-radius:999px;font-size:13px;cursor:pointer;background:#fff;user-select:none}
// // // .rc-chip.on{background:#fff1e8;border-color:#ea580c;color:#c2410c;font-weight:700}
// // // .rc-chip input{display:none}
// // // .rc-inline{display:flex;gap:8px;margin-top:12px}
// // // .rc-inline input{flex:1;border:1px solid #cbd5e1;border-radius:10px;padding:9px 12px;font-size:14px}
// // // .rc-drop{display:flex;align-items:center;gap:12px;padding:16px;border:1.5px dashed #cbd5e1;border-radius:12px;background:#f8fafc;cursor:pointer}
// // // .rc-drop:hover{border-color:#ea580c;background:#fff7f2}
// // // .rc-drop input{display:none}
// // // .rc-drop-icon{width:40px;height:40px;border-radius:10px;background:#fff1e8;color:#ea580c;display:grid;place-items:center;font-size:20px;font-weight:700}
// // // .rc-drop small{display:block;color:#64748b;font-size:12px;margin-top:2px}
// // // .rc-images{display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:12px;margin-top:14px}
// // // .rc-img{position:relative;border:1px solid #e2e8f0;border-radius:12px;overflow:hidden;background:#fff}
// // // .rc-img img{width:100%;height:110px;object-fit:cover;display:block}
// // // .rc-img-bar{display:flex;gap:6px;padding:8px;flex-wrap:wrap}
// // // .rc-tag{position:absolute;top:8px;left:8px;color:#fff;font-size:10px;font-weight:800;padding:3px 8px;border-radius:999px}
// // // .rc-footer{display:flex;justify-content:flex-end;gap:10px;position:sticky;bottom:0;background:#f8fafc;padding:14px 0;border-top:1px solid #e2e8f0}
// // // .rc-loading{padding:50px;text-align:center;color:#64748b}
// // // @media(max-width:700px){.rc-fields{grid-template-columns:1fr}}
// // // `;

// // // /* =====================================================
// // //    SMALL UI PIECES
// // // ===================================================== */

// // // function Field({ label, value, onChange, type = "text", placeholder = "", maxLength, full = false, min, step, hint }) {
// // //   return (
// // //     <div className={full ? "rc-field full" : "rc-field"}>
// // //       <label>{label}</label>
// // //       <input
// // //         type={type}
// // //         value={value}
// // //         placeholder={placeholder}
// // //         maxLength={maxLength}
// // //         min={min}
// // //         step={step}
// // //         onChange={(e) => onChange(e.target.value)}
// // //       />
// // //       {hint ? <div className="rc-hint">{hint}</div> : null}
// // //     </div>
// // //   );
// // // }

// // // function Toggle({ label, checked, onChange }) {
// // //   return (
// // //     <label className={checked ? "rc-chip on" : "rc-chip"}>
// // //       <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} />
// // //       {checked ? "✓ " : ""}{label}
// // //     </label>
// // //   );
// // // }

// // // /* =====================================================
// // //    ROOM CATEGORY FORM  (create + edit)
// // // ===================================================== */

// // // function RoomForm({ palaceId, room, onCancel, onSaved }) {
// // //   const isEdit = Boolean(room);

// // //   const [form, setForm] = useState(() => (room ? formFromRoom(room) : EMPTY_FORM));
// // //   const [newFiles, setNewFiles] = useState([]); // [{ file, preview }]
// // //   const [customAmenity, setCustomAmenity] = useState("");
// // //   const [saving, setSaving] = useState(false);
// // //   const [error, setError] = useState("");
// // //   const [step, setStep] = useState(0);
// // //   const steps = ["Basic information", "Size & beds", "Guest capacity", "Amenities", "Images"];

// // //   const existingImages = room?.images || [];
// // //   const coverPublicId = room?.coverImage?.publicId || "";

// // //   useEffect(
// // //     () => () => newFiles.forEach((f) => URL.revokeObjectURL(f.preview)),
// // //     // eslint-disable-next-line react-hooks/exhaustive-deps
// // //     []
// // //   );

// // //   const set = (name, value) => {
// // //     setForm((prev) => ({ ...prev, [name]: value }));
// // //     setError("");
// // //   };

// // //   const toggleAmenity = (name) =>
// // //     setForm((prev) => ({
// // //       ...prev,
// // //       amenities: prev.amenities.includes(name)
// // //         ? prev.amenities.filter((a) => a !== name)
// // //         : [...prev.amenities, name],
// // //     }));

// // //   const addCustomAmenity = () => {
// // //     const value = customAmenity.trim();
// // //     if (!value) return;

// // //     if (form.amenities.some((a) => a.toLowerCase() === value.toLowerCase())) {
// // //       setError(`"${value}" is already added.`);
// // //       return;
// // //     }

// // //     setForm((prev) => ({ ...prev, amenities: [...prev.amenities, value] }));
// // //     setCustomAmenity("");
// // //     setError("");
// // //   };

// // //   const pickFiles = (event) => {
// // //     const picked = [];
// // //     let problem = "";

// // //     Array.from(event.target.files || []).forEach((file) => {
// // //       if (!file.type.startsWith("image/")) {
// // //         problem = `${file.name}: only image files are allowed.`;
// // //         return;
// // //       }
// // //       if (file.size > MAX_IMAGE_MB * 1024 * 1024) {
// // //         problem = `${file.name} is larger than ${MAX_IMAGE_MB} MB.`;
// // //         return;
// // //       }
// // //       picked.push({ file, preview: URL.createObjectURL(file) });
// // //     });

// // //     event.target.value = "";

// // //     if (existingImages.length + newFiles.length + picked.length > MAX_IMAGES) {
// // //       picked.forEach((p) => URL.revokeObjectURL(p.preview));
// // //       setError(`A maximum of ${MAX_IMAGES} images is allowed.`);
// // //       return;
// // //     }

// // //     setError(problem);
// // //     if (picked.length) setNewFiles((prev) => [...prev, ...picked]);
// // //   };

// // //   const removeNewFile = (index) => {
// // //     URL.revokeObjectURL(newFiles[index].preview);
// // //     setNewFiles((prev) => prev.filter((_, i) => i !== index));
// // //   };

// // //   const handleNext = () => {
// // //     setError("");
// // //     if (step === 0) {
// // //       if (!form.name.trim()) return setError("Room category name is required.");
// // //       if (!Number.isInteger(Number(form.totalUnits)) || Number(form.totalUnits) < 1) {
// // //         return setError("Total units must be a whole number, at least 1.");
// // //       }
// // //     }
// // //     if (step === 1) {
// // //       if (!Number.isFinite(Number(form.roomSize)) || Number(form.roomSize) < 0) {
// // //         return setError("Room size must be 0 or more.");
// // //       }
// // //       if (!Number.isInteger(Number(form.bedCount)) || Number(form.bedCount) < 1) {
// // //         return setError("Bed count must be a whole number, at least 1.");
// // //       }
// // //     }
// // //     if (step === 2) {
// // //       const problem = validateForm(form);
// // //       if (problem && (
// // //         problem.includes("adults") || problem.includes("children") ||
// // //         problem.includes("guests") || problem.includes("mattress")
// // //       )) return setError(problem);
// // //     }
// // //     setStep((current) => Math.min(current + 1, steps.length - 1));
// // //     window.scrollTo({ top: 0, behavior: "smooth" });
// // //   };

// // //   const handleSubmit = async (event) => {
// // //     event.preventDefault();

// // //     const problem = validateForm(form);
// // //     if (problem) {
// // //       setError(problem);
// // //       window.scrollTo({ top: 0, behavior: "smooth" });
// // //       return;
// // //     }

// // //     if (!isEdit && !palaceId) {
// // //       setError("Please select a Palace before creating a room category.");
// // //       return;
// // //     }

// // //     const body = new FormData();

// // //     if (!isEdit) body.append("palaceId", palaceId);

// // //     body.append("name", form.name.trim());
// // //     body.append("description", form.description);
// // //     body.append("roomType", form.roomType);
// // //     body.append("roomSize", form.roomSize || "0");
// // //     body.append("roomSizeUnit", form.roomSizeUnit);
// // //     body.append("bedType", form.bedType.trim());
// // //     body.append("bedCount", form.bedCount);
// // //     body.append("totalUnits", form.totalUnits);
// // //     body.append("includedAdults", form.includedAdults);
// // //     body.append("maxAdults", form.maxAdults);
// // //     body.append("maxChildren", form.maxChildren);
// // //     body.append("maxGuests", form.maxGuests);
// // //     body.append("extraMattressAllowed", String(form.extraMattressAllowed));
// // //     body.append("maxExtraMattress", form.extraMattressAllowed ? form.maxExtraMattress : "0");

// // //     // backend parseAmenities() accepts a JSON string
// // //     body.append("amenities", JSON.stringify(form.amenities.map((a) => a.trim())));

// // //     // backend: upload.any() -> any field name works
// // //     newFiles.forEach((item) => body.append("images", item.file));

// // //     setSaving(true);
// // //     setError("");

// // //     try {
// // //       const data = await request(isEdit ? `${ROOM_API}/${room._id}` : ROOM_API, {
// // //         method: isEdit ? "PUT" : "POST",
// // //         body, // no Content-Type: browser sets multipart boundary
// // //       });

// // //       newFiles.forEach((f) => URL.revokeObjectURL(f.preview));
// // //       onSaved(
// // //         data.data,
// // //         isEdit ? "Room category updated successfully." : "Room category created successfully."
// // //       );
// // //     } catch (err) {
// // //       setError(err.message);
// // //       window.scrollTo({ top: 0, behavior: "smooth" });
// // //     } finally {
// // //       setSaving(false);
// // //     }
// // //   };

// // //   return (
// // //     <form className="rc-form" onSubmit={handleSubmit} noValidate>
// // //       <div className="rc-stepper">
// // //         {steps.map((label, index) => (
// // //           <div key={label} className={`rc-step ${index === step ? "active" : ""} ${index < step ? "done" : ""}`}>
// // //             <span>{index < step ? "✓" : index + 1}</span>
// // //             <small>{label}</small>
// // //           </div>
// // //         ))}
// // //       </div>
// // //       {error && <div className="rc-alert rc-err">{error}</div>}

// // //       {step === 0 && (
// // //         <>
// // //       <section className="rc-section">
// // //         <h3>Basic information</h3>
// // //         <div className="rc-fields">
// // //           <Field label="Room category name *" value={form.name} onChange={(v) => set("name", v)} maxLength={120} placeholder="e.g. Royal Heritage Suite" full />

// // //           <div className="rc-field">
// // //             <label>Room type</label>
// // //             <select value={form.roomType} onChange={(e) => set("roomType", e.target.value)}>
// // //               {ROOM_TYPES.map(([id, name]) => (
// // //                 <option key={id} value={id}>{name}</option>
// // //               ))}
// // //             </select>
// // //           </div>

// // //           <Field label="Total units (rooms of this type) *" type="number" min="1" step="1" value={form.totalUnits} onChange={(v) => set("totalUnits", v)} />

// // //           <div className="rc-field full">
// // //             <label>Description</label>
// // //             <textarea
// // //               rows={4}
// // //               maxLength={3000}
// // //               value={form.description}
// // //               placeholder="Describe the room, view, interiors..."
// // //               onChange={(e) => set("description", e.target.value)}
// // //             />
// // //             <div className="rc-count">{form.description.length}/3000</div>
// // //           </div>
// // //         </div>
// // //       </section>

// // //         </>
// // //       )}
// // //       {step === 1 && (
// // //         <>
// // //       <section className="rc-section">
// // //         <h3>Size and beds</h3>
// // //         <div className="rc-fields">
// // //           <Field label="Room size" type="number" min="0" step="any" value={form.roomSize} onChange={(v) => set("roomSize", v)} />

// // //           <div className="rc-field">
// // //             <label>Size unit</label>
// // //             <select value={form.roomSizeUnit} onChange={(e) => set("roomSizeUnit", e.target.value)}>
// // //               <option value="SQFT">Sq. ft</option>
// // //               <option value="SQM">Sq. m</option>
// // //             </select>
// // //           </div>

// // //           <Field label="Bed type" value={form.bedType} onChange={(v) => set("bedType", v)} placeholder="e.g. King, Twin, Queen" />
// // //           <Field label="Bed count" type="number" min="1" step="1" value={form.bedCount} onChange={(v) => set("bedCount", v)} />
// // //         </div>
// // //       </section>

// // //         </>
// // //       )}
// // //       {step === 2 && (
// // //         <>
// // //       <section className="rc-section">
// // //         <h3>Guest capacity</h3>
// // //         <div className="rc-fields">
// // //           <Field label="Included adults" type="number" min="1" step="1" value={form.includedAdults} onChange={(v) => set("includedAdults", v)} hint="Adults covered in the base price. Cannot exceed max adults." />
// // //           <Field label="Max adults" type="number" min="1" step="1" value={form.maxAdults} onChange={(v) => set("maxAdults", v)} />
// // //           <Field label="Max children" type="number" min="0" step="1" value={form.maxChildren} onChange={(v) => set("maxChildren", v)} />
// // //           <Field label="Max guests" type="number" min="1" step="1" value={form.maxGuests} onChange={(v) => set("maxGuests", v)} hint="Must be at least max adults + max children." />
// // //         </div>

// // //         <div className="rc-chips" style={{ marginTop: 16 }}>
// // //           <Toggle label="Extra mattress allowed" checked={form.extraMattressAllowed} onChange={(v) => set("extraMattressAllowed", v)} />
// // //         </div>

// // //         {form.extraMattressAllowed && (
// // //           <div className="rc-fields" style={{ marginTop: 14 }}>
// // //             <Field label="Max extra mattress" type="number" min="1" step="1" value={form.maxExtraMattress} onChange={(v) => set("maxExtraMattress", v)} />
// // //           </div>
// // //         )}
// // //       </section>

// // //         </>
// // //       )}
// // //       {step === 3 && (
// // //         <>
// // //       <section className="rc-section">
// // //         <h3>Room amenities</h3>
// // //         <div className="rc-chips">
// // //           {AMENITY_OPTIONS.map((name) => (
// // //             <Toggle key={name} label={name} checked={form.amenities.includes(name)} onChange={() => toggleAmenity(name)} />
// // //           ))}

// // //           {form.amenities
// // //             .filter((a) => !AMENITY_OPTIONS.includes(a))
// // //             .map((name) => (
// // //               <Toggle key={name} label={name} checked onChange={() => toggleAmenity(name)} />
// // //             ))}
// // //         </div>

// // //         <div className="rc-inline">
// // //           <input
// // //             value={customAmenity}
// // //             maxLength={100}
// // //             placeholder="Add other amenity"
// // //             onChange={(e) => setCustomAmenity(e.target.value)}
// // //             onKeyDown={(e) => {
// // //               if (e.key === "Enter") {
// // //                 e.preventDefault();
// // //                 addCustomAmenity();
// // //               }
// // //             }}
// // //           />
// // //           <button type="button" className="rc-btn rc-ghost" onClick={addCustomAmenity}>Add</button>
// // //         </div>
// // //       </section>

// // //         </>
// // //       )}
// // //       {step === 4 && (
// // //         <>
// // //       <section className="rc-section">
// // //         <h3>Room images ({existingImages.length + newFiles.length}/{MAX_IMAGES})</h3>

// // //         <label className="rc-drop">
// // //           <input type="file" accept="image/*" multiple onChange={pickFiles} />
// // //           <span className="rc-drop-icon">+</span>
// // //           <span>
// // //             <strong>Upload room images</strong>
// // //             <small>JPG, PNG, WEBP · max {MAX_IMAGE_MB} MB each · first image becomes the cover</small>
// // //           </span>
// // //         </label>

// // //         {(existingImages.length > 0 || newFiles.length > 0) && (
// // //           <div className="rc-images">
// // //             {existingImages.map((img) => (
// // //               <div className="rc-img" key={img.publicId || img.url}>
// // //                 <img src={img.url} alt="Room" />
// // //                 {img.publicId === coverPublicId && (
// // //                   <span className="rc-tag" style={{ background: "#ea580c" }}>COVER</span>
// // //                 )}
// // //               </div>
// // //             ))}

// // //             {newFiles.map((item, index) => (
// // //               <div className="rc-img" key={`${item.file.name}-${index}`}>
// // //                 <img src={item.preview} alt={item.file.name} />
// // //                 <span className="rc-tag" style={{ background: "#0f172a" }}>NEW</span>
// // //                 <div className="rc-img-bar">
// // //                   <button type="button" className="rc-btn rc-danger rc-small" onClick={() => removeNewFile(index)}>
// // //                     Remove
// // //                   </button>
// // //                 </div>
// // //               </div>
// // //             ))}
// // //           </div>
// // //         )}
// // //       </section>

// // //         </>
// // //       )}
// // //       <div className="rc-footer">
// // //         <button type="button" className="rc-btn rc-ghost" onClick={step === 0 ? onCancel : () => setStep((current) => Math.max(0, current - 1))} disabled={saving}>
// // //           {step === 0 ? "Cancel" : "Back"}
// // //         </button>
// // //         {step < steps.length - 1 ? (
// // //           <button type="button" className="rc-btn rc-primary" onClick={handleNext} disabled={saving}>
// // //             Next →
// // //           </button>
// // //         ) : (
// // //           <button type="submit" className="rc-btn rc-primary" disabled={saving}>
// // //             {saving ? "Saving..." : isEdit ? "Save changes" : "Create room category"}
// // //           </button>
// // //         )}
// // //       </div>
// // //     </form>
// // //   );
// // // }

// // // /* =====================================================
// // //    MAIN PAGE
// // // ===================================================== */

// // // export default function PalaceRoomCategories() {
// // //   const [palaces, setPalaces] = useState([]);
// // //   const [palaceId, setPalaceId] = useState("");
// // //   const [rooms, setRooms] = useState([]);

// // //   const [loadingPalaces, setLoadingPalaces] = useState(true);
// // //   const [loadingRooms, setLoadingRooms] = useState(false);

// // //   const [view, setView] = useState("list"); // "list" | "form"
// // //   const [editing, setEditing] = useState(null);

// // //   const [error, setError] = useState("");
// // //   const [success, setSuccess] = useState("");
// // //   const [busyId, setBusyId] = useState("");

// // //   /* ---------- load palaces once ---------- */

// // //   useEffect(() => {
// // //     let cancelled = false;

// // //     (async () => {
// // //       try {
// // //         const data = await request(PALACE_API);
// // //         if (cancelled) return;

// // //         const list = Array.isArray(data.data) ? data.data : [];
// // //         setPalaces(list);
// // //         if (list.length > 0) setPalaceId(list[0]._id);
// // //       } catch (err) {
// // //         if (!cancelled) setError(err.message);
// // //       } finally {
// // //         if (!cancelled) setLoadingPalaces(false);
// // //       }
// // //     })();

// // //     return () => {
// // //       cancelled = true;
// // //     };
// // //   }, []);

// // //   /* ---------- load rooms when palace changes ---------- */

// // //   const loadRooms = useCallback(async (id) => {
// // //     if (!id) {
// // //       setRooms([]);
// // //       return;
// // //     }

// // //     setLoadingRooms(true);
// // //     setError("");

// // //     try {
// // //       const data = await request(`${ROOM_API}/palace/${id}`);
// // //       setRooms(Array.isArray(data.data) ? data.data : []);
// // //     } catch (err) {
// // //       setError(err.message);
// // //       setRooms([]);
// // //     } finally {
// // //       setLoadingRooms(false);
// // //     }
// // //   }, []);

// // //   useEffect(() => {
// // //     loadRooms(palaceId);
// // //   }, [palaceId, loadRooms]);

// // //   /* ---------- actions ---------- */

// // //   const openCreate = () => {
// // //     setEditing(null);
// // //     setSuccess("");
// // //     setError("");
// // //     setView("form");
// // //   };

// // //   const openEdit = (room) => {
// // //     setEditing(room);
// // //     setSuccess("");
// // //     setError("");
// // //     setView("form");
// // //   };

// // //   const closeForm = () => {
// // //     setView("list");
// // //     setEditing(null);
// // //   };

// // //   const handleSaved = (saved, message) => {
// // //     setRooms((prev) =>
// // //       prev.some((r) => r._id === saved._id)
// // //         ? prev.map((r) => (r._id === saved._id ? saved : r))
// // //         : [saved, ...prev]
// // //     );
// // //     setSuccess(message);
// // //     closeForm();
// // //   };

// // //   const handleToggle = async (room) => {
// // //     setBusyId(room._id);
// // //     setError("");
// // //     setSuccess("");

// // //     try {
// // //       const data = await request(`${ROOM_API}/${room._id}/toggle`, { method: "PATCH" });
// // //       setRooms((prev) => prev.map((r) => (r._id === room._id ? data.data : r)));
// // //       setSuccess(data.message || "Status updated.");
// // //     } catch (err) {
// // //       setError(err.message);
// // //     } finally {
// // //       setBusyId("");
// // //     }
// // //   };

// // //   const handleDelete = async (room) => {
// // //     if (!window.confirm(`Delete "${room.name}" and all its images? This cannot be undone.`)) return;

// // //     setBusyId(room._id);
// // //     setError("");
// // //     setSuccess("");

// // //     try {
// // //       const data = await request(`${ROOM_API}/${room._id}`, { method: "DELETE" });
// // //       setRooms((prev) => prev.filter((r) => r._id !== room._id));
// // //       setSuccess(data.message || "Room category deleted.");
// // //     } catch (err) {
// // //       setError(err.message);
// // //     } finally {
// // //       setBusyId("");
// // //     }
// // //   };

// // //   const selectedPalace = palaces.find((p) => p._id === palaceId);

// // //   /* ---------- FORM VIEW ---------- */

// // //   if (view === "form") {
// // //     return (
// // //       <div className="rc-wrap">
// // //         <style>{css}</style>

// // //         <div className="rc-head">
// // //           <div>
// // //             <h2>{editing ? "Edit room category" : "Add room category"}</h2>
// // //             <p>
// // //               {editing
// // //                 ? `Update details of "${editing.name}". New images are added to the existing ones.`
// // //                 : `New room category for ${selectedPalace?.propertyName || "your palace"}.`}
// // //             </p>
// // //           </div>
// // //         </div>

// // //         <div className="rc-picker">
// // //           <label htmlFor="rc-form-palace">Selected Palace / Place</label>
// // //           <select
// // //             id="rc-form-palace"
// // //             value={palaceId}
// // //             onChange={(e) => {
// // //               setPalaceId(e.target.value);
// // //               localStorage.setItem("selectedPalaceId", e.target.value);
// // //             }}
// // //             disabled={Boolean(editing)}
// // //           >
// // //             {palaces.map((p) => (
// // //               <option key={p._id} value={p._id}>
// // //                 {p.propertyName}{p.address?.city ? ` — ${p.address.city}` : ""}
// // //               </option>
// // //             ))}
// // //           </select>
// // //           <small className="rc-hint">Palace ID: {palaceId || "No Palace selected"}</small>
// // //         </div>

// // //         <RoomForm
// // //           key={editing?._id || "new"}
// // //           palaceId={palaceId}
// // //           room={editing}
// // //           onCancel={closeForm}
// // //           onSaved={handleSaved}
// // //         />
// // //       </div>
// // //     );
// // //   }

// // //   /* ---------- LIST VIEW ---------- */

// // //   return (
// // //     <div className="rc-wrap">
// // //       <style>{css}</style>

// // //       <div className="rc-head">
// // //         <div>
// // //           <h2>Palace room categories</h2>
// // //           <p>Create room types (Deluxe, Suite, Royal...) for each of your palaces.</p>
// // //         </div>
// // //         <button
// // //           type="button"
// // //           className="rc-btn rc-primary"
// // //           onClick={openCreate}
// // //           disabled={!palaceId}
// // //         >
// // //           + Add room category
// // //         </button>
// // //       </div>

// // //       {success && <div className="rc-alert rc-ok">{success}</div>}
// // //       {error && <div className="rc-alert rc-err">{error}</div>}

// // //       {loadingPalaces ? (
// // //         <div className="rc-loading">Loading palaces...</div>
// // //       ) : palaces.length === 0 ? (
// // //         <div className="rc-empty">
// // //           <h3 style={{ margin: "0 0 6px", color: "#0f172a" }}>No palace found</h3>
// // //           <p style={{ margin: 0 }}>Pehle "My palaces" page se ek palace add karo, phir uske room categories bana sakte ho.</p>
// // //         </div>
// // //       ) : (
// // //         <>
// // //           <div className="rc-picker">
// // //             <label htmlFor="rc-palace">Palace</label>
// // //             <select id="rc-palace" value={palaceId} onChange={(e) => setPalaceId(e.target.value)}>
// // //               {palaces.map((p) => (
// // //                 <option key={p._id} value={p._id}>
// // //                   {p.propertyName}
// // //                   {p.address?.city ? ` — ${p.address.city}` : ""}
// // //                 </option>
// // //               ))}
// // //             </select>
// // //           </div>

// // //           {loadingRooms ? (
// // //             <div className="rc-loading">Loading room categories...</div>
// // //           ) : rooms.length === 0 ? (
// // //             <div className="rc-empty">
// // //               <h3 style={{ margin: "0 0 6px", color: "#0f172a" }}>No room categories yet</h3>
// // //               <p style={{ margin: "0 0 16px" }}>Add the first room category for this palace.</p>
// // //               <button type="button" className="rc-btn rc-primary" onClick={openCreate}>
// // //                 + Add room category
// // //               </button>
// // //             </div>
// // //           ) : (
// // //             <div className="rc-grid">
// // //               {rooms.map((room) => {
// // //                 const busy = busyId === room._id;
// // //                 const typeLabel = ROOM_TYPES.find(([id]) => id === room.roomType)?.[1] || room.roomType;

// // //                 return (
// // //                   <article className="rc-card" key={room._id}>
// // //                     <div className="rc-cover">
// // //                       {room.coverImage?.url ? (
// // //                         <img src={room.coverImage.url} alt={room.name} />
// // //                       ) : (
// // //                         <span>No cover image</span>
// // //                       )}
// // //                       <span
// // //                         className="rc-badge"
// // //                         style={
// // //                           room.isActive
// // //                             ? { color: "#166534", background: "#dcfce7" }
// // //                             : { color: "#334155", background: "#f1f5f9" }
// // //                         }
// // //                       >
// // //                         {room.isActive ? "Active" : "Inactive"}
// // //                       </span>
// // //                     </div>

// // //                     <div className="rc-body">
// // //                       <h3>{room.name}</h3>
// // //                       <div className="rc-meta">
// // //                         {typeLabel}
// // //                         {room.roomSize > 0 ? ` · ${room.roomSize} ${room.roomSizeUnit === "SQM" ? "sq m" : "sq ft"}` : ""}
// // //                       </div>
// // //                       <div className="rc-meta">
// // //                         {room.bedCount} {room.bedType || "bed"}{room.bedCount > 1 ? "s" : ""} · up to {room.maxGuests} guests
// // //                       </div>
// // //                       <div className="rc-meta">
// // //                         {room.totalUnits} unit{room.totalUnits > 1 ? "s" : ""} · {room.images?.length || 0} images
// // //                       </div>

// // //                       <div className="rc-actions">
// // //                         <button type="button" className="rc-btn rc-ghost rc-small" onClick={() => openEdit(room)} disabled={busy}>
// // //                           Edit
// // //                         </button>
// // //                         <button type="button" className="rc-btn rc-ghost rc-small" onClick={() => handleToggle(room)} disabled={busy}>
// // //                           {busy ? "..." : room.isActive ? "Deactivate" : "Activate"}
// // //                         </button>
// // //                         <button type="button" className="rc-btn rc-danger rc-small" onClick={() => handleDelete(room)} disabled={busy}>
// // //                           Delete
// // //                         </button>
// // //                       </div>
// // //                     </div>
// // //                   </article>
// // //                 );
// // //               })}
// // //             </div>
// // //           )}
// // //         </>
// // //       )}
// // //     </div>
// // //   );
// // // }





// // import { useCallback, useEffect, useRef, useState } from "react";

// // /* =====================================================
// //    API  (backend: /api/palaces + /api/palace-room-categories)
// // ===================================================== */

// // const API_BASE = process.env.REACT_APP_API_URL || "https://bmtvendorvendorfinal.onrender.com";
// // const PALACE_API = `${API_BASE}/api/palaces`;
// // const ROOM_API = `${API_BASE}/api/palace-room-categories`;

// // async function request(url, options = {}) {
// //   const token = localStorage.getItem("vendorToken");

// //   if (!token) {
// //     window.location.href = "/vendor-login";
// //     throw new Error("Session expired. Please login again.");
// //   }

// //   const response = await fetch(url, {
// //     ...options,
// //     headers: { Authorization: `Bearer ${token}`, ...(options.headers || {}) },
// //   });

// //   const data = await response.json().catch(() => ({}));

// //   if (response.status === 401) {
// //     localStorage.removeItem("vendorToken");
// //     localStorage.removeItem("vendorUser");
// //     window.location.href = "/vendor-login";
// //     throw new Error("Session expired. Please login again.");
// //   }

// //   if (!response.ok || data.success === false) {
// //     throw new Error(data.message || `Request failed (${response.status})`);
// //   }

// //   return data;
// // }

// // /* =====================================================
// //    OPTIONS / DEFAULTS  (same enums as palaceRoomCategoryModel.js)
// // ===================================================== */

// // const ROOM_TYPES = [
// //   ["DELUXE", "Deluxe"],
// //   ["PREMIUM", "Premium"],
// //   ["ROYAL", "Royal"],
// //   ["HERITAGE", "Heritage"],
// //   ["SUITE", "Suite"],
// //   ["MAHARAJA_SUITE", "Maharaja Suite"],
// //   ["VILLA", "Villa"],
// //   ["OTHER", "Other"],
// // ];

// // const AMENITY_OPTIONS = [
// //   "Air Conditioning", "Free Wi-Fi", "TV", "Mini Bar", "Tea / Coffee Maker",
// //   "Private Balcony", "Bathtub", "Attached Bathroom", "Safe / Locker", "Hair Dryer",
// //   "Work Desk", "Heating", "Garden View", "Palace View", "Pool View",
// //   "Room Service", "Butler Service",
// // ];

// // const MAX_IMAGES = 15;
// // const MAX_IMAGE_MB = 10;

// // const EMPTY_FORM = {
// //   name: "",
// //   description: "",
// //   roomType: "DELUXE",
// //   roomSize: "0",
// //   roomSizeUnit: "SQFT",
// //   bedType: "",
// //   bedCount: "1",
// //   totalUnits: "1",
// //   includedAdults: "2",
// //   maxAdults: "2",
// //   maxChildren: "0",
// //   maxGuests: "2",
// //   extraMattressAllowed: false,
// //   maxExtraMattress: "0",
// //   amenities: [],
// // };

// // const str = (v) => (v === undefined || v === null ? "" : String(v));

// // function formFromRoom(r) {
// //   return {
// //     name: str(r.name),
// //     description: str(r.description),
// //     roomType: r.roomType || "DELUXE",
// //     roomSize: str(r.roomSize ?? 0),
// //     roomSizeUnit: r.roomSizeUnit || "SQFT",
// //     bedType: str(r.bedType),
// //     bedCount: str(r.bedCount ?? 1),
// //     totalUnits: str(r.totalUnits ?? 1),
// //     includedAdults: str(r.includedAdults ?? 2),
// //     maxAdults: str(r.maxAdults ?? 2),
// //     maxChildren: str(r.maxChildren ?? 0),
// //     maxGuests: str(r.maxGuests ?? 2),
// //     extraMattressAllowed: Boolean(r.extraMattressAllowed),
// //     maxExtraMattress: str(r.maxExtraMattress ?? 0),
// //     amenities: Array.isArray(r.amenities) ? r.amenities : [],
// //   };
// // }

// // /* =====================================================
// //    VALIDATION  (same rules as palaceRoomCategoryController.js)
// // ===================================================== */

// // function validateForm(f) {
// //   if (!f.name.trim()) return "Room category name is required.";
// //   if (f.name.trim().length > 120) return "Name cannot exceed 120 characters.";

// //   const n = (v) => Number(v === "" ? NaN : v);

// //   const roomSize = n(f.roomSize);
// //   if (!Number.isFinite(roomSize) || roomSize < 0) return "Room size must be 0 or more.";

// //   const bedCount = n(f.bedCount);
// //   if (!Number.isInteger(bedCount) || bedCount < 1) return "Bed count must be a whole number, at least 1.";

// //   const totalUnits = n(f.totalUnits);
// //   if (!Number.isInteger(totalUnits) || totalUnits < 1) return "Total units must be a whole number, at least 1.";

// //   const includedAdults = n(f.includedAdults);
// //   const maxAdults = n(f.maxAdults);
// //   const maxChildren = n(f.maxChildren);
// //   const maxGuests = n(f.maxGuests);
// //   const maxExtraMattress = n(f.maxExtraMattress);

// //   if (!Number.isInteger(includedAdults) || includedAdults < 1) return "Included adults must be at least 1.";
// //   if (!Number.isInteger(maxAdults) || maxAdults < 1) return "Max adults must be at least 1.";
// //   if (!Number.isInteger(maxChildren) || maxChildren < 0) return "Max children must be 0 or more.";
// //   if (!Number.isInteger(maxGuests) || maxGuests < 1) return "Max guests must be at least 1.";
// //   if (!Number.isInteger(maxExtraMattress) || maxExtraMattress < 0) return "Max extra mattress must be 0 or more.";

// //   if (includedAdults > maxAdults) return "Included adults cannot exceed maximum adults.";
// //   if (maxGuests < includedAdults) return "Maximum guests cannot be less than included adults.";
// //   if (maxGuests < maxAdults + maxChildren) return "Maximum guests cannot be less than max adults plus max children.";

// //   if (f.extraMattressAllowed && maxExtraMattress < 1) {
// //     return "Set max extra mattress to 1 or more, or turn off extra mattress.";
// //   }

// //   const lower = f.amenities.map((a) => a.trim().toLowerCase());
// //   if (lower.some((a) => !a) || new Set(lower).size !== lower.length) {
// //     return "Amenities cannot be empty or duplicated.";
// //   }

// //   return "";
// // }

// // /* =====================================================
// //    STYLES (scoped with "rc-" prefix)
// // ===================================================== */

// // const css = `
// // .rc-wrap{font-family:'Inter','Segoe UI',Arial,sans-serif;color:#0f172a}
// // .rc-head{display:flex;justify-content:space-between;align-items:flex-start;gap:16px;flex-wrap:wrap;margin-bottom:22px}
// // .rc-head h2{margin:0 0 4px;font-size:26px;letter-spacing:-.5px}
// // .rc-head p{margin:0;color:#64748b;font-size:14px}
// // .rc-btn{border:0;border-radius:10px;padding:10px 18px;font-size:13px;font-weight:700;cursor:pointer;transition:.15s}
// // .rc-btn:disabled{opacity:.6;cursor:not-allowed}
// // .rc-primary{background:linear-gradient(135deg,#f97316,#ea580c);color:#fff}
// // .rc-ghost{background:#fff;border:1px solid #cbd5e1;color:#0f172a}
// // .rc-danger{background:#fff;border:1px solid #fecaca;color:#b91c1c}
// // .rc-small{padding:7px 12px;font-size:12px}
// // .rc-alert{padding:12px 14px;border-radius:10px;margin-bottom:16px;font-size:13px}
// // .rc-err{background:#fff7ed;border:1px solid #fed7aa;color:#9a3412}
// // .rc-ok{background:#f0fdf4;border:1px solid #bbf7d0;color:#166534}
// // .rc-picker{background:#fff;border:1px solid #e2e8f0;border-radius:16px;padding:16px 20px;margin-bottom:20px;display:flex;align-items:center;gap:14px;flex-wrap:wrap}
// // .rc-picker label{font-size:12px;font-weight:700;color:#374151}
// // .rc-picker select{flex:1;min-width:220px;border:1px solid #cbd5e1;border-radius:10px;padding:10px 12px;font-size:14px;background:#fff;color:#0f172a}
// // .rc-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));gap:18px}
// // .rc-card{background:#fff;border:1px solid #e2e8f0;border-radius:16px;overflow:hidden;display:flex;flex-direction:column}
// // .rc-cover{height:170px;background:#f1f5f9;display:grid;place-items:center;color:#94a3b8;font-size:13px;position:relative}
// // .rc-cover img{width:100%;height:100%;object-fit:cover;display:block}
// // .rc-badge{position:absolute;top:10px;left:10px;padding:4px 10px;border-radius:999px;font-size:11px;font-weight:800}
// // .rc-body{padding:16px;display:flex;flex-direction:column;gap:6px;flex:1}
// // .rc-body h3{margin:0;font-size:17px}
// // .rc-meta{font-size:12px;color:#64748b}
// // .rc-actions{display:flex;gap:8px;flex-wrap:wrap;margin-top:auto;padding-top:12px}
// // .rc-empty{background:#fff;border:1px dashed #cbd5e1;border-radius:16px;padding:48px 20px;text-align:center;color:#64748b}
// // .rc-form{display:flex;flex-direction:column;gap:18px}\n.rc-stepper{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:8px;background:#fff;border:1px solid #e2e8f0;border-radius:14px;padding:14px}\n.rc-step{display:flex;align-items:center;gap:8px;color:#94a3b8;font-size:12px;min-width:0}\n.rc-step span{display:grid;place-items:center;flex:0 0 28px;height:28px;border-radius:50%;background:#f1f5f9;font-weight:800}\n.rc-step small{font-size:11px;line-height:1.3}\n.rc-step.active{color:#c2410c;font-weight:800}\n.rc-step.active span,.rc-step.done span{background:#ea580c;color:#fff}\n.rc-step.done{color:#475569}\n@media(max-width:700px){.rc-stepper{grid-template-columns:1fr 1fr}.rc-step small{font-size:10px}}
// // .rc-section{background:#fff;border:1px solid #e2e8f0;border-radius:16px;padding:20px}
// // .rc-section h3{margin:0 0 14px;font-size:16px}
// // .rc-fields{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px}
// // .rc-field{display:flex;flex-direction:column;gap:6px}
// // .rc-field.full{grid-column:1/-1}
// // .rc-field label{font-size:12px;font-weight:700;color:#374151}
// // .rc-field input,.rc-field select,.rc-field textarea{border:1px solid #cbd5e1;border-radius:10px;padding:10px 12px;font-size:14px;font-family:inherit;color:#0f172a;background:#fff;outline:none;width:100%;box-sizing:border-box}
// // .rc-field input:focus,.rc-field select:focus,.rc-field textarea:focus{border-color:#ea580c}
// // .rc-hint{font-size:11px;color:#94a3b8}
// // .rc-count{font-size:11px;color:#94a3b8;text-align:right}
// // .rc-chips{display:flex;flex-wrap:wrap;gap:8px}
// // .rc-chip{display:inline-flex;align-items:center;gap:6px;padding:7px 12px;border:1px solid #cbd5e1;border-radius:999px;font-size:13px;cursor:pointer;background:#fff;user-select:none}
// // .rc-chip.on{background:#fff1e8;border-color:#ea580c;color:#c2410c;font-weight:700}
// // .rc-chip input{display:none}
// // .rc-inline{display:flex;gap:8px;margin-top:12px}
// // .rc-inline input{flex:1;border:1px solid #cbd5e1;border-radius:10px;padding:9px 12px;font-size:14px}
// // .rc-drop{display:flex;align-items:center;gap:12px;padding:16px;border:1.5px dashed #cbd5e1;border-radius:12px;background:#f8fafc;cursor:pointer}
// // .rc-drop:hover{border-color:#ea580c;background:#fff7f2}
// // .rc-drop input{position:absolute;width:1px;height:1px;opacity:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap}
// // .rc-upload-btn{display:inline-flex;align-items:center;gap:8px;border:1px solid #fed7aa;border-radius:10px;background:#fff;color:#c2410c;padding:9px 12px;font-size:13px;font-weight:700;cursor:pointer}
// // .rc-upload-btn:hover{background:#fff7ed}
// // .rc-upload-btn:disabled{opacity:.5;cursor:not-allowed}
// // .rc-drop-icon{width:40px;height:40px;border-radius:10px;background:#fff1e8;color:#ea580c;display:grid;place-items:center;font-size:20px;font-weight:700}
// // .rc-drop small{display:block;color:#64748b;font-size:12px;margin-top:2px}
// // .rc-images{display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:12px;margin-top:14px}
// // .rc-img{position:relative;border:1px solid #e2e8f0;border-radius:12px;overflow:hidden;background:#fff}
// // .rc-img img{width:100%;height:110px;object-fit:cover;display:block}
// // .rc-img-bar{display:flex;gap:6px;padding:8px;flex-wrap:wrap}
// // .rc-tag{position:absolute;top:8px;left:8px;color:#fff;font-size:10px;font-weight:800;padding:3px 8px;border-radius:999px}
// // .rc-footer{display:flex;justify-content:flex-end;gap:10px;position:sticky;bottom:0;background:#f8fafc;padding:14px 0;border-top:1px solid #e2e8f0}
// // .rc-loading{padding:50px;text-align:center;color:#64748b}
// // @media(max-width:700px){.rc-fields{grid-template-columns:1fr}}
// // `;

// // /* =====================================================
// //    SMALL UI PIECES
// // ===================================================== */

// // function Field({ label, value, onChange, type = "text", placeholder = "", maxLength, full = false, min, step, hint }) {
// //   return (
// //     <div className={full ? "rc-field full" : "rc-field"}>
// //       <label>{label}</label>
// //       <input
// //         type={type}
// //         value={value}
// //         placeholder={placeholder}
// //         maxLength={maxLength}
// //         min={min}
// //         step={step}
// //         onChange={(e) => onChange(e.target.value)}
// //       />
// //       {hint ? <div className="rc-hint">{hint}</div> : null}
// //     </div>
// //   );
// // }

// // function Toggle({ label, checked, onChange }) {
// //   return (
// //     <label className={checked ? "rc-chip on" : "rc-chip"}>
// //       <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} />
// //       {checked ? "✓ " : ""}{label}
// //     </label>
// //   );
// // }

// // /* =====================================================
// //    ROOM CATEGORY FORM  (create + edit)
// // ===================================================== */

// // function RoomForm({ palaceId, room, onCancel, onSaved }) {
// //   const isEdit = Boolean(room);

// //   const [form, setForm] = useState(() => (room ? formFromRoom(room) : EMPTY_FORM));
// //   const [newFiles, setNewFiles] = useState([]); // [{ file, preview }]
// //   const fileInputRef = useRef(null);
// //   const [customAmenity, setCustomAmenity] = useState("");
// //   const [saving, setSaving] = useState(false);
// //   const [error, setError] = useState("");
// //   const [step, setStep] = useState(0);
// //   const steps = ["Basic information", "Size & beds", "Guest capacity", "Amenities", "Images"];

// //   const existingImages = room?.images || [];
// //   const coverPublicId = room?.coverImage?.publicId || "";

// //   useEffect(
// //     () => () => newFiles.forEach((f) => URL.revokeObjectURL(f.preview)),
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //     []
// //   );

// //   const set = (name, value) => {
// //     setForm((prev) => ({ ...prev, [name]: value }));
// //     setError("");
// //   };

// //   const toggleAmenity = (name) =>
// //     setForm((prev) => ({
// //       ...prev,
// //       amenities: prev.amenities.includes(name)
// //         ? prev.amenities.filter((a) => a !== name)
// //         : [...prev.amenities, name],
// //     }));

// //   const addCustomAmenity = () => {
// //     const value = customAmenity.trim();
// //     if (!value) return;

// //     if (form.amenities.some((a) => a.toLowerCase() === value.toLowerCase())) {
// //       setError(`"${value}" is already added.`);
// //       return;
// //     }

// //     setForm((prev) => ({ ...prev, amenities: [...prev.amenities, value] }));
// //     setCustomAmenity("");
// //     setError("");
// //   };

// //   const pickFiles = (event) => {
// //     const picked = [];
// //     let problem = "";

// //     Array.from(event.target.files || []).forEach((file) => {
// //       if (!file.type.startsWith("image/")) {
// //         problem = `${file.name}: only image files are allowed.`;
// //         return;
// //       }
// //       if (file.size > MAX_IMAGE_MB * 1024 * 1024) {
// //         problem = `${file.name} is larger than ${MAX_IMAGE_MB} MB.`;
// //         return;
// //       }
// //       picked.push({ file, preview: URL.createObjectURL(file) });
// //     });

// //     event.target.value = "";

// //     if (existingImages.length + newFiles.length + picked.length > MAX_IMAGES) {
// //       picked.forEach((p) => URL.revokeObjectURL(p.preview));
// //       setError(`A maximum of ${MAX_IMAGES} images is allowed.`);
// //       return;
// //     }

// //     setError(problem);
// //     if (picked.length) setNewFiles((prev) => [...prev, ...picked]);
// //   };

// //   const removeNewFile = (index) => {
// //     URL.revokeObjectURL(newFiles[index].preview);
// //     setNewFiles((prev) => prev.filter((_, i) => i !== index));
// //   };

// //   const handleNext = () => {
// //     setError("");
// //     if (step === 0) {
// //       if (!form.name.trim()) return setError("Room category name is required.");
// //       if (!Number.isInteger(Number(form.totalUnits)) || Number(form.totalUnits) < 1) {
// //         return setError("Total units must be a whole number, at least 1.");
// //       }
// //     }
// //     if (step === 1) {
// //       if (!Number.isFinite(Number(form.roomSize)) || Number(form.roomSize) < 0) {
// //         return setError("Room size must be 0 or more.");
// //       }
// //       if (!Number.isInteger(Number(form.bedCount)) || Number(form.bedCount) < 1) {
// //         return setError("Bed count must be a whole number, at least 1.");
// //       }
// //     }
// //     if (step === 2) {
// //       const problem = validateForm(form);
// //       if (problem && (
// //         problem.includes("adults") || problem.includes("children") ||
// //         problem.includes("guests") || problem.includes("mattress")
// //       )) return setError(problem);
// //     }
// //     setStep((current) => Math.min(current + 1, steps.length - 1));
// //     window.scrollTo({ top: 0, behavior: "smooth" });
// //   };

// //   const handleSubmit = async (event) => {
// //     event.preventDefault();

// //     const problem = validateForm(form);
// //     if (problem) {
// //       setError(problem);
// //       window.scrollTo({ top: 0, behavior: "smooth" });
// //       return;
// //     }

// //     if (!isEdit && !palaceId) {
// //       setError("Please select a Palace before creating a room category.");
// //       return;
// //     }

// //     const body = new FormData();

// //     if (!isEdit) body.append("palaceId", palaceId);

// //     body.append("name", form.name.trim());
// //     body.append("description", form.description);
// //     body.append("roomType", form.roomType);
// //     body.append("roomSize", form.roomSize || "0");
// //     body.append("roomSizeUnit", form.roomSizeUnit);
// //     body.append("bedType", form.bedType.trim());
// //     body.append("bedCount", form.bedCount);
// //     body.append("totalUnits", form.totalUnits);
// //     body.append("includedAdults", form.includedAdults);
// //     body.append("maxAdults", form.maxAdults);
// //     body.append("maxChildren", form.maxChildren);
// //     body.append("maxGuests", form.maxGuests);
// //     body.append("extraMattressAllowed", String(form.extraMattressAllowed));
// //     body.append("maxExtraMattress", form.extraMattressAllowed ? form.maxExtraMattress : "0");

// //     // backend parseAmenities() accepts a JSON string
// //     body.append("amenities", JSON.stringify(form.amenities.map((a) => a.trim())));

// //     // backend: upload.any() -> any field name works
// //     newFiles.forEach((item) => body.append("images", item.file));

// //     setSaving(true);
// //     setError("");

// //     try {
// //       const data = await request(isEdit ? `${ROOM_API}/${room._id}` : ROOM_API, {
// //         method: isEdit ? "PUT" : "POST",
// //         body, // no Content-Type: browser sets multipart boundary
// //       });

// //       newFiles.forEach((f) => URL.revokeObjectURL(f.preview));
// //       onSaved(
// //         data.data,
// //         isEdit ? "Room category updated successfully." : "Room category created successfully."
// //       );
// //     } catch (err) {
// //       setError(err.message);
// //       window.scrollTo({ top: 0, behavior: "smooth" });
// //     } finally {
// //       setSaving(false);
// //     }
// //   };

// //   return (
// //     <form className="rc-form" onSubmit={handleSubmit} noValidate>
// //       <div className="rc-stepper">
// //         {steps.map((label, index) => (
// //           <div key={label} className={`rc-step ${index === step ? "active" : ""} ${index < step ? "done" : ""}`}>
// //             <span>{index < step ? "✓" : index + 1}</span>
// //             <small>{label}</small>
// //           </div>
// //         ))}
// //       </div>
// //       {error && <div className="rc-alert rc-err">{error}</div>}

// //       {step === 0 && (
// //         <>
// //       <section className="rc-section">
// //         <h3>Basic information</h3>
// //         <div className="rc-fields">
// //           <Field label="Room category name *" value={form.name} onChange={(v) => set("name", v)} maxLength={120} placeholder="e.g. Royal Heritage Suite" full />

// //           <div className="rc-field">
// //             <label>Room type</label>
// //             <select value={form.roomType} onChange={(e) => set("roomType", e.target.value)}>
// //               {ROOM_TYPES.map(([id, name]) => (
// //                 <option key={id} value={id}>{name}</option>
// //               ))}
// //             </select>
// //           </div>

// //           <Field label="Total units (rooms of this type) *" type="number" min="1" step="1" value={form.totalUnits} onChange={(v) => set("totalUnits", v)} />

// //           <div className="rc-field full">
// //             <label>Description</label>
// //             <textarea
// //               rows={4}
// //               maxLength={3000}
// //               value={form.description}
// //               placeholder="Describe the room, view, interiors..."
// //               onChange={(e) => set("description", e.target.value)}
// //             />
// //             <div className="rc-count">{form.description.length}/3000</div>
// //           </div>
// //         </div>
// //       </section>

// //         </>
// //       )}
// //       {step === 1 && (
// //         <>
// //       <section className="rc-section">
// //         <h3>Size and beds</h3>
// //         <div className="rc-fields">
// //           <Field label="Room size" type="number" min="0" step="any" value={form.roomSize} onChange={(v) => set("roomSize", v)} />

// //           <div className="rc-field">
// //             <label>Size unit</label>
// //             <select value={form.roomSizeUnit} onChange={(e) => set("roomSizeUnit", e.target.value)}>
// //               <option value="SQFT">Sq. ft</option>
// //               <option value="SQM">Sq. m</option>
// //             </select>
// //           </div>

// //           <Field label="Bed type" value={form.bedType} onChange={(v) => set("bedType", v)} placeholder="e.g. King, Twin, Queen" />
// //           <Field label="Bed count" type="number" min="1" step="1" value={form.bedCount} onChange={(v) => set("bedCount", v)} />
// //         </div>
// //       </section>

// //         </>
// //       )}
// //       {step === 2 && (
// //         <>
// //       <section className="rc-section">
// //         <h3>Guest capacity</h3>
// //         <div className="rc-fields">
// //           <Field label="Included adults" type="number" min="1" step="1" value={form.includedAdults} onChange={(v) => set("includedAdults", v)} hint="Adults covered in the base price. Cannot exceed max adults." />
// //           <Field label="Max adults" type="number" min="1" step="1" value={form.maxAdults} onChange={(v) => set("maxAdults", v)} />
// //           <Field label="Max children" type="number" min="0" step="1" value={form.maxChildren} onChange={(v) => set("maxChildren", v)} />
// //           <Field label="Max guests" type="number" min="1" step="1" value={form.maxGuests} onChange={(v) => set("maxGuests", v)} hint="Must be at least max adults + max children." />
// //         </div>

// //         <div className="rc-chips" style={{ marginTop: 16 }}>
// //           <Toggle label="Extra mattress allowed" checked={form.extraMattressAllowed} onChange={(v) => set("extraMattressAllowed", v)} />
// //         </div>

// //         {form.extraMattressAllowed && (
// //           <div className="rc-fields" style={{ marginTop: 14 }}>
// //             <Field label="Max extra mattress" type="number" min="1" step="1" value={form.maxExtraMattress} onChange={(v) => set("maxExtraMattress", v)} />
// //           </div>
// //         )}
// //       </section>

// //         </>
// //       )}
// //       {step === 3 && (
// //         <>
// //       <section className="rc-section">
// //         <h3>Room amenities</h3>
// //         <div className="rc-chips">
// //           {AMENITY_OPTIONS.map((name) => (
// //             <Toggle key={name} label={name} checked={form.amenities.includes(name)} onChange={() => toggleAmenity(name)} />
// //           ))}

// //           {form.amenities
// //             .filter((a) => !AMENITY_OPTIONS.includes(a))
// //             .map((name) => (
// //               <Toggle key={name} label={name} checked onChange={() => toggleAmenity(name)} />
// //             ))}
// //         </div>

// //         <div className="rc-inline">
// //           <input
// //             value={customAmenity}
// //             maxLength={100}
// //             placeholder="Add other amenity"
// //             onChange={(e) => setCustomAmenity(e.target.value)}
// //             onKeyDown={(e) => {
// //               if (e.key === "Enter") {
// //                 e.preventDefault();
// //                 addCustomAmenity();
// //               }
// //             }}
// //           />
// //           <button type="button" className="rc-btn rc-ghost" onClick={addCustomAmenity}>Add</button>
// //         </div>
// //       </section>

// //         </>
// //       )}
// //       {step === 4 && (
// //         <>
// //       <section className="rc-section">
// //         <h3>Room images ({existingImages.length + newFiles.length}/{MAX_IMAGES})</h3>

// //         <div className="rc-drop">
// //           <input
// //             ref={fileInputRef}
// //             type="file"
// //             accept="image/jpeg,image/png,image/webp,image/gif,image/*"
// //             multiple
// //             onChange={pickFiles}
// //           />
// //           <span className="rc-drop-icon">+</span>
// //           <span style={{ flex: 1 }}>
// //             <strong>Upload room images</strong>
// //             <small>JPG, PNG, WEBP · max {MAX_IMAGE_MB} MB each · first new image becomes the cover</small>
// //           </span>
// //           <button
// //             type="button"
// //             className="rc-upload-btn"
// //             onClick={() => fileInputRef.current?.click()}
// //             disabled={saving || existingImages.length + newFiles.length >= MAX_IMAGES}
// //           >
// //             Choose images
// //           </button>
// //         </div>

// //         {(existingImages.length > 0 || newFiles.length > 0) && (
// //           <div className="rc-images">
// //             {existingImages.map((img) => (
// //               <div className="rc-img" key={img.publicId || img.url}>
// //                 <img src={img.url} alt="Room" />
// //                 {img.publicId === coverPublicId && (
// //                   <span className="rc-tag" style={{ background: "#ea580c" }}>COVER</span>
// //                 )}
// //               </div>
// //             ))}

// //             {newFiles.map((item, index) => (
// //               <div className="rc-img" key={`${item.file.name}-${index}`}>
// //                 <img src={item.preview} alt={item.file.name} />
// //                 <span className="rc-tag" style={{ background: "#0f172a" }}>NEW</span>
// //                 <div className="rc-img-bar">
// //                   <button type="button" className="rc-btn rc-danger rc-small" onClick={() => removeNewFile(index)}>
// //                     Remove
// //                   </button>
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //         )}
// //       </section>

// //         </>
// //       )}
// //       <div className="rc-footer">
// //         <button type="button" className="rc-btn rc-ghost" onClick={step === 0 ? onCancel : () => setStep((current) => Math.max(0, current - 1))} disabled={saving}>
// //           {step === 0 ? "Cancel" : "Back"}
// //         </button>
// //         {step < steps.length - 1 ? (
// //           <button type="button" className="rc-btn rc-primary" onClick={handleNext} disabled={saving}>
// //             Next →
// //           </button>
// //         ) : (
// //           <button type="submit" className="rc-btn rc-primary" disabled={saving}>
// //             {saving ? "Saving..." : isEdit ? "Save changes" : "Create room category"}
// //           </button>
// //         )}
// //       </div>
// //     </form>
// //   );
// // }

// // /* =====================================================
// //    MAIN PAGE
// // ===================================================== */

// // export default function PalaceRoomCategories() {
// //   const [palaces, setPalaces] = useState([]);
// //   const [palaceId, setPalaceId] = useState("");
// //   const [rooms, setRooms] = useState([]);

// //   const [loadingPalaces, setLoadingPalaces] = useState(true);
// //   const [loadingRooms, setLoadingRooms] = useState(false);

// //   const [view, setView] = useState("list"); // "list" | "form"
// //   const [editing, setEditing] = useState(null);

// //   const [error, setError] = useState("");
// //   const [success, setSuccess] = useState("");
// //   const [busyId, setBusyId] = useState("");

// //   /* ---------- load palaces once ---------- */

// //   useEffect(() => {
// //     let cancelled = false;

// //     (async () => {
// //       try {
// //         const data = await request(PALACE_API);
// //         if (cancelled) return;

// //         const list = Array.isArray(data.data) ? data.data : Array.isArray(data.palaces) ? data.palaces : Array.isArray(data.results) ? data.results : [];
// //         setPalaces(list);
// //         if (list.length > 0) {
// //           const savedPalaceId = localStorage.getItem("selectedPalaceId");
// //           const selected = list.find((p) => p._id === savedPalaceId);
// //           const nextPalaceId = selected?._id || list[0]._id;
// //           setPalaceId(nextPalaceId);
// //           localStorage.setItem("selectedPalaceId", nextPalaceId);
// //         } else {
// //           setPalaceId("");
// //           localStorage.removeItem("selectedPalaceId");
// //         }
// //       } catch (err) {
// //         if (!cancelled) setError(err.message);
// //       } finally {
// //         if (!cancelled) setLoadingPalaces(false);
// //       }
// //     })();

// //     return () => {
// //       cancelled = true;
// //     };
// //   }, []);

// //   /* ---------- load rooms when palace changes ---------- */

// //   const loadRooms = useCallback(async (id) => {
// //     if (!id) {
// //       setRooms([]);
// //       return;
// //     }

// //     setLoadingRooms(true);
// //     setError("");

// //     try {
// //       const data = await request(`${ROOM_API}/palace/${id}`);
// //       setRooms(Array.isArray(data.data) ? data.data : []);
// //     } catch (err) {
// //       setError(err.message);
// //       setRooms([]);
// //     } finally {
// //       setLoadingRooms(false);
// //     }
// //   }, []);

// //   useEffect(() => {
// //     loadRooms(palaceId);
// //   }, [palaceId, loadRooms]);

// //   /* ---------- actions ---------- */

// //   const openCreate = () => {
// //     setEditing(null);
// //     setSuccess("");
// //     setError("");
// //     setView("form");
// //   };

// //   const openEdit = (room) => {
// //     setEditing(room);
// //     setSuccess("");
// //     setError("");
// //     setView("form");
// //   };

// //   const closeForm = () => {
// //     setView("list");
// //     setEditing(null);
// //   };

// //   const handleSaved = (saved, message) => {
// //     setRooms((prev) =>
// //       prev.some((r) => r._id === saved._id)
// //         ? prev.map((r) => (r._id === saved._id ? saved : r))
// //         : [saved, ...prev]
// //     );
// //     setSuccess(message);
// //     closeForm();
// //     loadRooms(palaceId);
// //   };

// //   const handleToggle = async (room) => {
// //     setBusyId(room._id);
// //     setError("");
// //     setSuccess("");

// //     try {
// //       const data = await request(`${ROOM_API}/${room._id}/toggle`, { method: "PATCH" });
// //       setRooms((prev) => prev.map((r) => (r._id === room._id ? data.data : r)));
// //       setSuccess(data.message || "Status updated.");
// //     } catch (err) {
// //       setError(err.message);
// //     } finally {
// //       setBusyId("");
// //     }
// //   };

// //   const handleDelete = async (room) => {
// //     if (!window.confirm(`Delete "${room.name}" and all its images? This cannot be undone.`)) return;

// //     setBusyId(room._id);
// //     setError("");
// //     setSuccess("");

// //     try {
// //       const data = await request(`${ROOM_API}/${room._id}`, { method: "DELETE" });
// //       setRooms((prev) => prev.filter((r) => r._id !== room._id));
// //       setSuccess(data.message || "Room category deleted.");
// //       loadRooms(palaceId);
// //     } catch (err) {
// //       setError(err.message);
// //     } finally {
// //       setBusyId("");
// //     }
// //   };

// //   const selectedPalace = palaces.find((p) => p._id === palaceId);

// //   /* ---------- FORM VIEW ---------- */

// //   if (view === "form") {
// //     return (
// //       <div className="rc-wrap">
// //         <style>{css}</style>

// //         <div className="rc-head">
// //           <div>
// //             <h2>{editing ? "Edit room category" : "Add room category"}</h2>
// //             <p>
// //               {editing
// //                 ? `Update details of "${editing.name}". New images are added to the existing ones.`
// //                 : `New room category for ${selectedPalace?.propertyName || "your palace"}.`}
// //             </p>
// //           </div>
// //         </div>

// //         <div className="rc-picker">
// //           <label htmlFor="rc-form-palace">Select Palace / Place (choose which property gets this room category)</label>
// //           <select
// //             id="rc-form-palace"
// //             value={palaceId}
// //             onChange={(e) => {
// //               setPalaceId(e.target.value);
// //               localStorage.setItem("selectedPalaceId", e.target.value);
// //             }}
// //             disabled={Boolean(editing)}
// //           >
// //             {palaces.map((p) => (
// //               <option key={p._id} value={p._id}>
// //                 {p.propertyName}{p.address?.city ? ` — ${p.address.city}` : ""}
// //               </option>
// //             ))}
// //           </select>
// //           <small className="rc-hint">Palace ID: {palaceId || "No Palace selected"}</small>
// //         </div>

// //         <RoomForm
// //           key={`${editing?._id || "new"}-${palaceId}`}
// //           palaceId={palaceId}
// //           room={editing}
// //           onCancel={closeForm}
// //           onSaved={handleSaved}
// //         />
// //       </div>
// //     );
// //   }

// //   /* ---------- LIST VIEW ---------- */

// //   return (
// //     <div className="rc-wrap">
// //       <style>{css}</style>

// //       <div className="rc-head">
// //         <div>
// //           <h2>Palace room categories</h2>
// //           <p>Create room types (Deluxe, Suite, Royal...) for each of your palaces.</p>
// //         </div>
// //         <button
// //           type="button"
// //           className="rc-btn rc-primary"
// //           onClick={openCreate}
// //           disabled={!palaceId}
// //         >
// //           + Add room category
// //         </button>
// //       </div>

// //       {success && <div className="rc-alert rc-ok">{success}</div>}
// //       {error && <div className="rc-alert rc-err">{error}</div>}

// //       {loadingPalaces ? (
// //         <div className="rc-loading">Loading palaces...</div>
// //       ) : palaces.length === 0 ? (
// //         <div className="rc-empty">
// //           <h3 style={{ margin: "0 0 6px", color: "#0f172a" }}>No palace found</h3>
// //           <p style={{ margin: 0 }}>Pehle "My palaces" page se ek palace add karo, phir uske room categories bana sakte ho.</p>
// //         </div>
// //       ) : (
// //         <>
// //           <div className="rc-picker">
// //             <label htmlFor="rc-palace">Select Palace / Place — rooms are shown separately for each property</label>
// //             <select id="rc-palace" value={palaceId} onChange={(e) => {
// //               setPalaceId(e.target.value);
// //               localStorage.setItem("selectedPalaceId", e.target.value);
// //             }}>
// //               {palaces.map((p) => (
// //                 <option key={p._id} value={p._id}>
// //                   {p.propertyName}
// //                   {p.address?.city ? ` — ${p.address.city}` : ""}
// //                 </option>
// //               ))}
// //             </select>
// //           </div>

// //           {loadingRooms ? (
// //             <div className="rc-loading">Loading room categories...</div>
// //           ) : rooms.length === 0 ? (
// //             <div className="rc-empty">
// //               <h3 style={{ margin: "0 0 6px", color: "#0f172a" }}>No room categories yet</h3>
// //               <p style={{ margin: "0 0 16px" }}>Add the first room category for this palace.</p>
// //               <button type="button" className="rc-btn rc-primary" onClick={openCreate}>
// //                 + Add room category
// //               </button>
// //             </div>
// //           ) : (
// //             <div className="rc-grid">
// //               {rooms.map((room) => {
// //                 const busy = busyId === room._id;
// //                 const typeLabel = ROOM_TYPES.find(([id]) => id === room.roomType)?.[1] || room.roomType;

// //                 return (
// //                   <article className="rc-card" key={room._id}>
// //                     <div className="rc-cover">
// //                       {room.coverImage?.url ? (
// //                         <img src={room.coverImage.url} alt={room.name} />
// //                       ) : (
// //                         <span>No cover image</span>
// //                       )}
// //                       <span
// //                         className="rc-badge"
// //                         style={
// //                           room.isActive
// //                             ? { color: "#166534", background: "#dcfce7" }
// //                             : { color: "#334155", background: "#f1f5f9" }
// //                         }
// //                       >
// //                         {room.isActive ? "Active" : "Inactive"}
// //                       </span>
// //                     </div>

// //                     <div className="rc-body">
// //                       <h3>{room.name}</h3>
// //                       <div className="rc-meta">
// //                         {typeLabel}
// //                         {room.roomSize > 0 ? ` · ${room.roomSize} ${room.roomSizeUnit === "SQM" ? "sq m" : "sq ft"}` : ""}
// //                       </div>
// //                       <div className="rc-meta">
// //                         {room.bedCount} {room.bedType || "bed"}{room.bedCount > 1 ? "s" : ""} · up to {room.maxGuests} guests
// //                       </div>
// //                       <div className="rc-meta">
// //                         {room.totalUnits} unit{room.totalUnits > 1 ? "s" : ""} · {room.images?.length || 0} images
// //                       </div>

// //                       <div className="rc-actions">
// //                         <button type="button" className="rc-btn rc-ghost rc-small" onClick={() => openEdit(room)} disabled={busy}>
// //                           Edit
// //                         </button>
// //                         <button type="button" className="rc-btn rc-ghost rc-small" onClick={() => handleToggle(room)} disabled={busy}>
// //                           {busy ? "..." : room.isActive ? "Deactivate" : "Activate"}
// //                         </button>
// //                         <button type="button" className="rc-btn rc-danger rc-small" onClick={() => handleDelete(room)} disabled={busy}>
// //                           Delete
// //                         </button>
// //                       </div>
// //                     </div>
// //                   </article>
// //                 );
// //               })}
// //             </div>
// //           )}
// //         </>
// //       )}
// //     </div>
// //   );
// // }










// import { useCallback, useEffect, useState } from "react";

// /* =====================================================
//    API  (backend: /api/palaces + /api/palace-room-categories)
// ===================================================== */

// const API_BASE = process.env.REACT_APP_API_URL || "https://bmtvendorvendorfinal.onrender.com";
// const PALACE_API = `${API_BASE}/api/palaces`;
// const ROOM_API = `${API_BASE}/api/palace-room-categories`;

// async function request(url, options = {}) {
//   const token = localStorage.getItem("vendorToken");

//   if (!token) {
//     window.location.href = "/vendor-login";
//     throw new Error("Session expired. Please login again.");
//   }

//   const response = await fetch(url, {
//     ...options,
//     headers: { Authorization: `Bearer ${token}`, ...(options.headers || {}) },
//   });

//   const data = await response.json().catch(() => ({}));

//   if (response.status === 401) {
//     localStorage.removeItem("vendorToken");
//     localStorage.removeItem("vendorUser");
//     window.location.href = "/vendor-login";
//     throw new Error("Session expired. Please login again.");
//   }

//   if (!response.ok || data.success === false) {
//     throw new Error(data.message || `Request failed (${response.status})`);
//   }

//   return data;
// }

// /* =====================================================
//    OPTIONS / DEFAULTS  (same enums as palaceRoomCategoryModel.js)
// ===================================================== */

// const ROOM_TYPES = [
//   ["DELUXE", "Deluxe"],
//   ["PREMIUM", "Premium"],
//   ["ROYAL", "Royal"],
//   ["HERITAGE", "Heritage"],
//   ["SUITE", "Suite"],
//   ["MAHARAJA_SUITE", "Maharaja Suite"],
//   ["VILLA", "Villa"],
//   ["OTHER", "Other"],
// ];

// const AMENITY_OPTIONS = [
//   "Air Conditioning", "Free Wi-Fi", "TV", "Mini Bar", "Tea / Coffee Maker",
//   "Private Balcony", "Bathtub", "Attached Bathroom", "Safe / Locker", "Hair Dryer",
//   "Work Desk", "Heating", "Garden View", "Palace View", "Pool View",
//   "Room Service", "Butler Service",
// ];

// const MAX_IMAGES = 15;
// const MAX_IMAGE_MB = 10;

// const EMPTY_FORM = {
//   name: "",
//   description: "",
//   roomType: "DELUXE",
//   roomSize: "0",
//   roomSizeUnit: "SQFT",
//   bedType: "",
//   bedCount: "1",
//   totalUnits: "1",
//   includedAdults: "2",
//   maxAdults: "2",
//   maxChildren: "0",
//   maxGuests: "2",
//   extraMattressAllowed: false,
//   maxExtraMattress: "0",
//   amenities: [],
// };

// const str = (v) => (v === undefined || v === null ? "" : String(v));

// function formFromRoom(r) {
//   return {
//     name: str(r.name),
//     description: str(r.description),
//     roomType: r.roomType || "DELUXE",
//     roomSize: str(r.roomSize ?? 0),
//     roomSizeUnit: r.roomSizeUnit || "SQFT",
//     bedType: str(r.bedType),
//     bedCount: str(r.bedCount ?? 1),
//     totalUnits: str(r.totalUnits ?? 1),
//     includedAdults: str(r.includedAdults ?? 2),
//     maxAdults: str(r.maxAdults ?? 2),
//     maxChildren: str(r.maxChildren ?? 0),
//     maxGuests: str(r.maxGuests ?? 2),
//     extraMattressAllowed: Boolean(r.extraMattressAllowed),
//     maxExtraMattress: str(r.maxExtraMattress ?? 0),
//     amenities: Array.isArray(r.amenities) ? r.amenities : [],
//   };
// }

// /* =====================================================
//    VALIDATION  (same rules as palaceRoomCategoryController.js)
// ===================================================== */

// function validateForm(f) {
//   if (!f.name.trim()) return "Room category name is required.";
//   if (f.name.trim().length > 120) return "Name cannot exceed 120 characters.";

//   const n = (v) => Number(v === "" ? NaN : v);

//   const roomSize = n(f.roomSize);
//   if (!Number.isFinite(roomSize) || roomSize < 0) return "Room size must be 0 or more.";

//   const bedCount = n(f.bedCount);
//   if (!Number.isInteger(bedCount) || bedCount < 1) return "Bed count must be a whole number, at least 1.";

//   const totalUnits = n(f.totalUnits);
//   if (!Number.isInteger(totalUnits) || totalUnits < 1) return "Total units must be a whole number, at least 1.";

//   const includedAdults = n(f.includedAdults);
//   const maxAdults = n(f.maxAdults);
//   const maxChildren = n(f.maxChildren);
//   const maxGuests = n(f.maxGuests);
//   const maxExtraMattress = n(f.maxExtraMattress);

//   if (!Number.isInteger(includedAdults) || includedAdults < 1) return "Included adults must be at least 1.";
//   if (!Number.isInteger(maxAdults) || maxAdults < 1) return "Max adults must be at least 1.";
//   if (!Number.isInteger(maxChildren) || maxChildren < 0) return "Max children must be 0 or more.";
//   if (!Number.isInteger(maxGuests) || maxGuests < 1) return "Max guests must be at least 1.";
//   if (!Number.isInteger(maxExtraMattress) || maxExtraMattress < 0) return "Max extra mattress must be 0 or more.";

//   if (includedAdults > maxAdults) return "Included adults cannot exceed maximum adults.";
//   if (maxGuests < includedAdults) return "Maximum guests cannot be less than included adults.";
//   if (maxGuests < maxAdults + maxChildren) return "Maximum guests cannot be less than max adults plus max children.";

//   if (f.extraMattressAllowed && maxExtraMattress < 1) {
//     return "Set max extra mattress to 1 or more, or turn off extra mattress.";
//   }

//   const lower = f.amenities.map((a) => a.trim().toLowerCase());
//   if (lower.some((a) => !a) || new Set(lower).size !== lower.length) {
//     return "Amenities cannot be empty or duplicated.";
//   }

//   return "";
// }

// /* =====================================================
//    STYLES (scoped with "rc-" prefix)
// ===================================================== */

// const css = `
// .rc-wrap{font-family:'Inter','Segoe UI',Arial,sans-serif;color:#0f172a}
// .rc-head{display:flex;justify-content:space-between;align-items:flex-start;gap:16px;flex-wrap:wrap;margin-bottom:22px}
// .rc-head h2{margin:0 0 4px;font-size:26px;letter-spacing:-.5px}
// .rc-head p{margin:0;color:#64748b;font-size:14px}
// .rc-btn{border:0;border-radius:10px;padding:10px 18px;font-size:13px;font-weight:700;cursor:pointer;transition:.15s}
// .rc-btn:disabled{opacity:.6;cursor:not-allowed}
// .rc-primary{background:linear-gradient(135deg,#f97316,#ea580c);color:#fff}
// .rc-ghost{background:#fff;border:1px solid #cbd5e1;color:#0f172a}
// .rc-danger{background:#fff;border:1px solid #fecaca;color:#b91c1c}
// .rc-small{padding:7px 12px;font-size:12px}
// .rc-alert{padding:12px 14px;border-radius:10px;margin-bottom:16px;font-size:13px}
// .rc-err{background:#fff7ed;border:1px solid #fed7aa;color:#9a3412}
// .rc-ok{background:#f0fdf4;border:1px solid #bbf7d0;color:#166534}
// .rc-picker{background:#fff;border:1px solid #e2e8f0;border-radius:16px;padding:16px 20px;margin-bottom:20px;display:flex;align-items:center;gap:14px;flex-wrap:wrap}
// .rc-picker label{font-size:12px;font-weight:700;color:#374151}
// .rc-picker select{flex:1;min-width:220px;border:1px solid #cbd5e1;border-radius:10px;padding:10px 12px;font-size:14px;background:#fff;color:#0f172a}
// .rc-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));gap:18px}
// .rc-card{background:#fff;border:1px solid #e2e8f0;border-radius:16px;overflow:hidden;display:flex;flex-direction:column}
// .rc-cover{height:170px;background:#f1f5f9;display:grid;place-items:center;color:#94a3b8;font-size:13px;position:relative}
// .rc-cover img{width:100%;height:100%;object-fit:cover;display:block}
// .rc-badge{position:absolute;top:10px;left:10px;padding:4px 10px;border-radius:999px;font-size:11px;font-weight:800}
// .rc-body{padding:16px;display:flex;flex-direction:column;gap:6px;flex:1}
// .rc-body h3{margin:0;font-size:17px}
// .rc-meta{font-size:12px;color:#64748b}
// .rc-actions{display:flex;gap:8px;flex-wrap:wrap;margin-top:auto;padding-top:12px}
// .rc-empty{background:#fff;border:1px dashed #cbd5e1;border-radius:16px;padding:48px 20px;text-align:center;color:#64748b}
// .rc-form{display:flex;flex-direction:column;gap:18px}\n.rc-stepper{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:8px;background:#fff;border:1px solid #e2e8f0;border-radius:14px;padding:14px}\n.rc-step{display:flex;align-items:center;gap:8px;color:#94a3b8;font-size:12px;min-width:0}\n.rc-step span{display:grid;place-items:center;flex:0 0 28px;height:28px;border-radius:50%;background:#f1f5f9;font-weight:800}\n.rc-step small{font-size:11px;line-height:1.3}\n.rc-step.active{color:#c2410c;font-weight:800}\n.rc-step.active span,.rc-step.done span{background:#ea580c;color:#fff}\n.rc-step.done{color:#475569}\n@media(max-width:700px){.rc-stepper{grid-template-columns:1fr 1fr}.rc-step small{font-size:10px}}
// .rc-section{background:#fff;border:1px solid #e2e8f0;border-radius:16px;padding:20px}
// .rc-section h3{margin:0 0 14px;font-size:16px}
// .rc-fields{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px}
// .rc-field{display:flex;flex-direction:column;gap:6px}
// .rc-field.full{grid-column:1/-1}
// .rc-field label{font-size:12px;font-weight:700;color:#374151}
// .rc-field input,.rc-field select,.rc-field textarea{border:1px solid #cbd5e1;border-radius:10px;padding:10px 12px;font-size:14px;font-family:inherit;color:#0f172a;background:#fff;outline:none;width:100%;box-sizing:border-box}
// .rc-field input:focus,.rc-field select:focus,.rc-field textarea:focus{border-color:#ea580c}
// .rc-hint{font-size:11px;color:#94a3b8}
// .rc-count{font-size:11px;color:#94a3b8;text-align:right}
// .rc-chips{display:flex;flex-wrap:wrap;gap:8px}
// .rc-chip{display:inline-flex;align-items:center;gap:6px;padding:7px 12px;border:1px solid #cbd5e1;border-radius:999px;font-size:13px;cursor:pointer;background:#fff;user-select:none}
// .rc-chip.on{background:#fff1e8;border-color:#ea580c;color:#c2410c;font-weight:700}
// .rc-chip input{display:none}
// .rc-inline{display:flex;gap:8px;margin-top:12px}
// .rc-inline input{flex:1;border:1px solid #cbd5e1;border-radius:10px;padding:9px 12px;font-size:14px}
// .rc-drop{display:flex;align-items:center;gap:12px;padding:16px;border:1.5px dashed #cbd5e1;border-radius:12px;background:#f8fafc;cursor:pointer}
// .rc-drop:hover{border-color:#ea580c;background:#fff7f2}
// .rc-drop input{position:absolute;width:1px;height:1px;opacity:0;pointer-events:none}.rc-choose{display:inline-flex;align-items:center;gap:8px;background:#ea580c;color:#fff;border:0;border-radius:8px;padding:9px 13px;font-size:12px;font-weight:800;cursor:pointer}.rc-drop{position:relative}
// .rc-drop-icon{width:40px;height:40px;border-radius:10px;background:#fff1e8;color:#ea580c;display:grid;place-items:center;font-size:20px;font-weight:700}
// .rc-drop small{display:block;color:#64748b;font-size:12px;margin-top:2px}
// .rc-images{display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:12px;margin-top:14px}
// .rc-img{position:relative;border:1px solid #e2e8f0;border-radius:12px;overflow:hidden;background:#fff}
// .rc-img img{width:100%;height:110px;object-fit:cover;display:block}
// .rc-img-bar{display:flex;gap:6px;padding:8px;flex-wrap:wrap}
// .rc-tag{position:absolute;top:8px;left:8px;color:#fff;font-size:10px;font-weight:800;padding:3px 8px;border-radius:999px}
// .rc-footer{display:flex;justify-content:flex-end;gap:10px;position:sticky;bottom:0;background:#f8fafc;padding:14px 0;border-top:1px solid #e2e8f0}
// .rc-loading{padding:50px;text-align:center;color:#64748b}
// @media(max-width:700px){.rc-fields{grid-template-columns:1fr}}
// `;

// /* =====================================================
//    SMALL UI PIECES
// ===================================================== */

// function Field({ label, value, onChange, type = "text", placeholder = "", maxLength, full = false, min, step, hint }) {
//   return (
//     <div className={full ? "rc-field full" : "rc-field"}>
//       <label>{label}</label>
//       <input
//         type={type}
//         value={value}
//         placeholder={placeholder}
//         maxLength={maxLength}
//         min={min}
//         step={step}
//         onChange={(e) => onChange(e.target.value)}
//       />
//       {hint ? <div className="rc-hint">{hint}</div> : null}
//     </div>
//   );
// }

// function Toggle({ label, checked, onChange }) {
//   return (
//     <label className={checked ? "rc-chip on" : "rc-chip"}>
//       <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} />
//       {checked ? "✓ " : ""}{label}
//     </label>
//   );
// }

// /* =====================================================
//    ROOM CATEGORY FORM  (create + edit)
// ===================================================== */

// function RoomForm({ palaceId, room, onCancel, onSaved }) {
//   const isEdit = Boolean(room);

//   const [form, setForm] = useState(() => (room ? formFromRoom(room) : EMPTY_FORM));
//   const [newFiles, setNewFiles] = useState([]); // [{ file, preview }]
//   const [customAmenity, setCustomAmenity] = useState("");
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState("");
//   const [step, setStep] = useState(0);
//   const steps = ["Basic information", "Size & beds", "Guest capacity", "Amenities", "Images"];

//   const existingImages = room?.images || [];
//   const coverPublicId = room?.coverImage?.publicId || "";

//   useEffect(
//     () => () => newFiles.forEach((f) => URL.revokeObjectURL(f.preview)),
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     []
//   );

//   const set = (name, value) => {
//     setForm((prev) => ({ ...prev, [name]: value }));
//     setError("");
//   };

//   const toggleAmenity = (name) =>
//     setForm((prev) => ({
//       ...prev,
//       amenities: prev.amenities.includes(name)
//         ? prev.amenities.filter((a) => a !== name)
//         : [...prev.amenities, name],
//     }));

//   const addCustomAmenity = () => {
//     const value = customAmenity.trim();
//     if (!value) return;

//     if (form.amenities.some((a) => a.toLowerCase() === value.toLowerCase())) {
//       setError(`"${value}" is already added.`);
//       return;
//     }

//     setForm((prev) => ({ ...prev, amenities: [...prev.amenities, value] }));
//     setCustomAmenity("");
//     setError("");
//   };

//   const pickFiles = (event) => {
//     const picked = [];
//     let problem = "";

//     Array.from(event.target.files || []).forEach((file) => {
//       if (!file.type.startsWith("image/")) {
//         problem = `${file.name}: only image files are allowed.`;
//         return;
//       }
//       if (file.size > MAX_IMAGE_MB * 1024 * 1024) {
//         problem = `${file.name} is larger than ${MAX_IMAGE_MB} MB.`;
//         return;
//       }
//       picked.push({ file, preview: URL.createObjectURL(file) });
//     });

//     event.target.value = "";

//     if (existingImages.length + newFiles.length + picked.length > MAX_IMAGES) {
//       picked.forEach((p) => URL.revokeObjectURL(p.preview));
//       setError(`A maximum of ${MAX_IMAGES} images is allowed.`);
//       return;
//     }

//     setError(problem);
//     if (picked.length) setNewFiles((prev) => [...prev, ...picked]);
//   };

//   const removeNewFile = (index) => {
//     URL.revokeObjectURL(newFiles[index].preview);
//     setNewFiles((prev) => prev.filter((_, i) => i !== index));
//   };

//   const handleNext = () => {
//     setError("");
//     if (step === 0) {
//       if (!form.name.trim()) return setError("Room category name is required.");
//       if (!Number.isInteger(Number(form.totalUnits)) || Number(form.totalUnits) < 1) {
//         return setError("Total units must be a whole number, at least 1.");
//       }
//     }
//     if (step === 1) {
//       if (!Number.isFinite(Number(form.roomSize)) || Number(form.roomSize) < 0) {
//         return setError("Room size must be 0 or more.");
//       }
//       if (!Number.isInteger(Number(form.bedCount)) || Number(form.bedCount) < 1) {
//         return setError("Bed count must be a whole number, at least 1.");
//       }
//     }
//     if (step === 2) {
//       const problem = validateForm(form);
//       if (problem && (
//         problem.includes("adults") || problem.includes("children") ||
//         problem.includes("guests") || problem.includes("mattress")
//       )) return setError(problem);
//     }
//     // Amenities is step 4 (index 3): Next must open Images (index 4), never submit.
//     setStep((current) => Math.min(current + 1, 4));
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();

//     // Safety guard: an implicit Enter/form submit before the Images step
//     // must never save the category early.
//     if (step !== 4) {
//       handleNext();
//       return;
//     }

//     const problem = validateForm(form);
//     if (problem) {
//       setError(problem);
//       window.scrollTo({ top: 0, behavior: "smooth" });
//       return;
//     }

//     if (!isEdit && !palaceId) {
//       setError("Please select a Palace before creating a room category.");
//       return;
//     }

//     const body = new FormData();

//     if (!isEdit) body.append("palaceId", palaceId);

//     body.append("name", form.name.trim());
//     body.append("description", form.description);
//     body.append("roomType", form.roomType);
//     body.append("roomSize", form.roomSize || "0");
//     body.append("roomSizeUnit", form.roomSizeUnit);
//     body.append("bedType", form.bedType.trim());
//     body.append("bedCount", form.bedCount);
//     body.append("totalUnits", form.totalUnits);
//     body.append("includedAdults", form.includedAdults);
//     body.append("maxAdults", form.maxAdults);
//     body.append("maxChildren", form.maxChildren);
//     body.append("maxGuests", form.maxGuests);
//     body.append("extraMattressAllowed", String(form.extraMattressAllowed));
//     body.append("maxExtraMattress", form.extraMattressAllowed ? form.maxExtraMattress : "0");

//     // backend parseAmenities() accepts a JSON string
//     body.append("amenities", JSON.stringify(form.amenities.map((a) => a.trim())));

//     // backend: upload.any() -> any field name works
//     newFiles.forEach((item) => body.append("images", item.file));

//     setSaving(true);
//     setError("");

//     try {
//       const data = await request(isEdit ? `${ROOM_API}/${room._id}` : ROOM_API, {
//         method: isEdit ? "PUT" : "POST",
//         body, // no Content-Type: browser sets multipart boundary
//       });

//       newFiles.forEach((f) => URL.revokeObjectURL(f.preview));
//       onSaved(
//         data.data,
//         isEdit ? "Room category updated successfully." : "Room category created successfully."
//       );
//     } catch (err) {
//       setError(err.message);
//       window.scrollTo({ top: 0, behavior: "smooth" });
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <form className="rc-form" onSubmit={handleSubmit} noValidate>
//       <div className="rc-stepper">
//         {steps.map((label, index) => (
//           <div key={label} className={`rc-step ${index === step ? "active" : ""} ${index < step ? "done" : ""}`}>
//             <span>{index < step ? "✓" : index + 1}</span>
//             <small>{label}</small>
//           </div>
//         ))}
//       </div>
//       {error && <div className="rc-alert rc-err">{error}</div>}

//       {step === 0 && (
//         <>
//       <section className="rc-section">
//         <h3>Basic information</h3>
//         <div className="rc-fields">
//           <Field label="Room category name *" value={form.name} onChange={(v) => set("name", v)} maxLength={120} placeholder="e.g. Royal Heritage Suite" full />

//           <div className="rc-field">
//             <label>Room type</label>
//             <select value={form.roomType} onChange={(e) => set("roomType", e.target.value)}>
//               {ROOM_TYPES.map(([id, name]) => (
//                 <option key={id} value={id}>{name}</option>
//               ))}
//             </select>
//           </div>

//           <Field label="Total units (rooms of this type) *" type="number" min="1" step="1" value={form.totalUnits} onChange={(v) => set("totalUnits", v)} />

//           <div className="rc-field full">
//             <label>Description</label>
//             <textarea
//               rows={4}
//               maxLength={3000}
//               value={form.description}
//               placeholder="Describe the room, view, interiors..."
//               onChange={(e) => set("description", e.target.value)}
//             />
//             <div className="rc-count">{form.description.length}/3000</div>
//           </div>
//         </div>
//       </section>

//         </>
//       )}
//       {step === 1 && (
//         <>
//       <section className="rc-section">
//         <h3>Size and beds</h3>
//         <div className="rc-fields">
//           <Field label="Room size" type="number" min="0" step="any" value={form.roomSize} onChange={(v) => set("roomSize", v)} />

//           <div className="rc-field">
//             <label>Size unit</label>
//             <select value={form.roomSizeUnit} onChange={(e) => set("roomSizeUnit", e.target.value)}>
//               <option value="SQFT">Sq. ft</option>
//               <option value="SQM">Sq. m</option>
//             </select>
//           </div>

//           <Field label="Bed type" value={form.bedType} onChange={(v) => set("bedType", v)} placeholder="e.g. King, Twin, Queen" />
//           <Field label="Bed count" type="number" min="1" step="1" value={form.bedCount} onChange={(v) => set("bedCount", v)} />
//         </div>
//       </section>

//         </>
//       )}
//       {step === 2 && (
//         <>
//       <section className="rc-section">
//         <h3>Guest capacity</h3>
//         <div className="rc-fields">
//           <Field label="Included adults" type="number" min="1" step="1" value={form.includedAdults} onChange={(v) => set("includedAdults", v)} hint="Adults covered in the base price. Cannot exceed max adults." />
//           <Field label="Max adults" type="number" min="1" step="1" value={form.maxAdults} onChange={(v) => set("maxAdults", v)} />
//           <Field label="Max children" type="number" min="0" step="1" value={form.maxChildren} onChange={(v) => set("maxChildren", v)} />
//           <Field label="Max guests" type="number" min="1" step="1" value={form.maxGuests} onChange={(v) => set("maxGuests", v)} hint="Must be at least max adults + max children." />
//         </div>

//         <div className="rc-chips" style={{ marginTop: 16 }}>
//           <Toggle label="Extra mattress allowed" checked={form.extraMattressAllowed} onChange={(v) => set("extraMattressAllowed", v)} />
//         </div>

//         {form.extraMattressAllowed && (
//           <div className="rc-fields" style={{ marginTop: 14 }}>
//             <Field label="Max extra mattress" type="number" min="1" step="1" value={form.maxExtraMattress} onChange={(v) => set("maxExtraMattress", v)} />
//           </div>
//         )}
//       </section>

//         </>
//       )}
//       {step === 3 && (
//         <>
//       <section className="rc-section">
//         <h3>Room amenities</h3>
//         <div className="rc-chips">
//           {AMENITY_OPTIONS.map((name) => (
//             <Toggle key={name} label={name} checked={form.amenities.includes(name)} onChange={() => toggleAmenity(name)} />
//           ))}

//           {form.amenities
//             .filter((a) => !AMENITY_OPTIONS.includes(a))
//             .map((name) => (
//               <Toggle key={name} label={name} checked onChange={() => toggleAmenity(name)} />
//             ))}
//         </div>

//         <div className="rc-inline">
//           <input
//             value={customAmenity}
//             maxLength={100}
//             placeholder="Add other amenity"
//             onChange={(e) => setCustomAmenity(e.target.value)}
//             onKeyDown={(e) => {
//               if (e.key === "Enter") {
//                 e.preventDefault();
//                 addCustomAmenity();
//               }
//             }}
//           />
//           <button type="button" className="rc-btn rc-ghost" onClick={addCustomAmenity}>Add</button>
//         </div>
//       </section>

//         </>
//       )}
//       {step === 4 && (
//         <>
//       <section className="rc-section">
//         <h3>Room images ({existingImages.length + newFiles.length}/{MAX_IMAGES})</h3>

//         <div className="rc-drop">
//           <input
//             id="rc-room-image-input"
//             type="file"
//             accept="image/jpeg,image/png,image/webp,image/gif"
//             multiple
//             onChange={pickFiles}
//           />
//           <span className="rc-drop-icon">+</span>
//           <div style={{ flex: 1 }}>
//             <strong>Upload room images</strong>
//             <small>JPG, PNG, WEBP or GIF · max {MAX_IMAGE_MB} MB each · up to {MAX_IMAGES} images</small>
//           </div>
//           <button type="button" className="rc-choose" onClick={() => document.getElementById("rc-room-image-input")?.click()}>
//             Choose images
//           </button>
//         </div>

//         {(existingImages.length > 0 || newFiles.length > 0) && (
//           <div className="rc-images">
//             {existingImages.map((img) => (
//               <div className="rc-img" key={img.publicId || img.url}>
//                 <img src={img.url} alt="Room" />
//                 {img.publicId === coverPublicId && (
//                   <span className="rc-tag" style={{ background: "#ea580c" }}>COVER</span>
//                 )}
//               </div>
//             ))}

//             {newFiles.map((item, index) => (
//               <div className="rc-img" key={`${item.file.name}-${index}`}>
//                 <img src={item.preview} alt={item.file.name} />
//                 <span className="rc-tag" style={{ background: "#0f172a" }}>NEW</span>
//                 <div className="rc-img-bar">
//                   <button type="button" className="rc-btn rc-danger rc-small" onClick={() => removeNewFile(index)}>
//                     Remove
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </section>

//         </>
//       )}
//       <div className="rc-footer">
//         <button type="button" className="rc-btn rc-ghost" onClick={step === 0 ? onCancel : () => setStep((current) => Math.max(0, current - 1))} disabled={saving}>
//           {step === 0 ? "Cancel" : "Back"}
//         </button>
//         {step !== 4 ? (
//           <button type="button" className="rc-btn rc-primary" onClick={handleNext} disabled={saving}>
//             Next →
//           </button>
//         ) : (
//           <button type="submit" className="rc-btn rc-primary" disabled={saving}>
//             {saving ? "Uploading & saving..." : isEdit ? "Save changes" : "Create room category"}
//           </button>
//         )}
//       </div>
//     </form>
//   );
// }

// /* =====================================================
//    MAIN PAGE
// ===================================================== */

// export default function PalaceRoomCategories() {
//   const [palaces, setPalaces] = useState([]);
//   const [palaceId, setPalaceId] = useState("");
//   const [rooms, setRooms] = useState([]);

//   const [loadingPalaces, setLoadingPalaces] = useState(true);
//   const [loadingRooms, setLoadingRooms] = useState(false);

//   const [view, setView] = useState("list"); // "list" | "form"
//   const [editing, setEditing] = useState(null);

//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");
//   const [busyId, setBusyId] = useState("");

//   /* ---------- load palaces once ---------- */

//   useEffect(() => {
//     let cancelled = false;

//     (async () => {
//       try {
//         const data = await request(PALACE_API);
//         if (cancelled) return;

//         const list = Array.isArray(data.data) ? data.data : [];
//         setPalaces(list);
//         if (list.length > 0) setPalaceId(list[0]._id);
//       } catch (err) {
//         if (!cancelled) setError(err.message);
//       } finally {
//         if (!cancelled) setLoadingPalaces(false);
//       }
//     })();

//     return () => {
//       cancelled = true;
//     };
//   }, []);

//   /* ---------- load rooms when palace changes ---------- */

//   const loadRooms = useCallback(async (id) => {
//     if (!id) {
//       setRooms([]);
//       return;
//     }

//     setLoadingRooms(true);
//     setError("");

//     try {
//       const data = await request(`${ROOM_API}/palace/${id}`);
//       setRooms(Array.isArray(data.data) ? data.data : []);
//     } catch (err) {
//       setError(err.message);
//       setRooms([]);
//     } finally {
//       setLoadingRooms(false);
//     }
//   }, []);

//   useEffect(() => {
//     loadRooms(palaceId);
//   }, [palaceId, loadRooms]);

//   /* ---------- actions ---------- */

//   const openCreate = () => {
//     setEditing(null);
//     setSuccess("");
//     setError("");
//     setView("form");
//   };

//   const openEdit = (room) => {
//     setEditing(room);
//     setSuccess("");
//     setError("");
//     setView("form");
//   };

//   const closeForm = () => {
//     setView("list");
//     setEditing(null);
//   };

//   const handleSaved = (saved, message) => {
//     setRooms((prev) =>
//       prev.some((r) => r._id === saved._id)
//         ? prev.map((r) => (r._id === saved._id ? saved : r))
//         : [saved, ...prev]
//     );
//     setSuccess(message);
//     closeForm();
//   };

//   const handleToggle = async (room) => {
//     setBusyId(room._id);
//     setError("");
//     setSuccess("");

//     try {
//       const data = await request(`${ROOM_API}/${room._id}/toggle`, { method: "PATCH" });
//       setRooms((prev) => prev.map((r) => (r._id === room._id ? data.data : r)));
//       setSuccess(data.message || "Status updated.");
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setBusyId("");
//     }
//   };

//   const handleDelete = async (room) => {
//     if (!window.confirm(`Delete "${room.name}" and all its images? This cannot be undone.`)) return;

//     setBusyId(room._id);
//     setError("");
//     setSuccess("");

//     try {
//       const data = await request(`${ROOM_API}/${room._id}`, { method: "DELETE" });
//       setRooms((prev) => prev.filter((r) => r._id !== room._id));
//       setSuccess(data.message || "Room category deleted.");
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setBusyId("");
//     }
//   };

//   const selectedPalace = palaces.find((p) => p._id === palaceId);

//   /* ---------- FORM VIEW ---------- */

//   if (view === "form") {
//     return (
//       <div className="rc-wrap">
//         <style>{css}</style>

//         <div className="rc-head">
//           <div>
//             <h2>{editing ? "Edit room category" : "Add room category"}</h2>
//             <p>
//               {editing
//                 ? `Update details of "${editing.name}". New images are added to the existing ones.`
//                 : `New room category for ${selectedPalace?.propertyName || "your palace"}.`}
//             </p>
//           </div>
//         </div>

//         <div className="rc-picker">
//           <label htmlFor="rc-form-palace">Selected Palace / Place</label>
//           <select
//             id="rc-form-palace"
//             value={palaceId}
//             onChange={(e) => {
//               setPalaceId(e.target.value);
//               localStorage.setItem("selectedPalaceId", e.target.value);
//             }}
//             disabled={Boolean(editing)}
//           >
//             {palaces.map((p) => (
//               <option key={p._id} value={p._id}>
//                 {p.propertyName}{p.address?.city ? ` — ${p.address.city}` : ""}
//               </option>
//             ))}
//           </select>
//           <small className="rc-hint">Palace ID: {palaceId || "No Palace selected"}</small>
//         </div>

//         <RoomForm
//           key={editing?._id || "new"}
//           palaceId={palaceId}
//           room={editing}
//           onCancel={closeForm}
//           onSaved={handleSaved}
//         />
//       </div>
//     );
//   }

//   /* ---------- LIST VIEW ---------- */

//   return (
//     <div className="rc-wrap">
//       <style>{css}</style>

//       <div className="rc-head">
//         <div>
//           <h2>Palace room categories</h2>
//           <p>Create room types (Deluxe, Suite, Royal...) for each of your palaces.</p>
//         </div>
//         <button
//           type="button"
//           className="rc-btn rc-primary"
//           onClick={openCreate}
//           disabled={!palaceId}
//         >
//           + Add room category
//         </button>
//       </div>

//       {success && <div className="rc-alert rc-ok">{success}</div>}
//       {error && <div className="rc-alert rc-err">{error}</div>}

//       {loadingPalaces ? (
//         <div className="rc-loading">Loading palaces...</div>
//       ) : palaces.length === 0 ? (
//         <div className="rc-empty">
//           <h3 style={{ margin: "0 0 6px", color: "#0f172a" }}>No palace found</h3>
//           <p style={{ margin: 0 }}>Pehle "My palaces" page se ek palace add karo, phir uske room categories bana sakte ho.</p>
//         </div>
//       ) : (
//         <>
//           <div className="rc-picker">
//             <label htmlFor="rc-palace">Palace</label>
//             <select id="rc-palace" value={palaceId} onChange={(e) => setPalaceId(e.target.value)}>
//               {palaces.map((p) => (
//                 <option key={p._id} value={p._id}>
//                   {p.propertyName}
//                   {p.address?.city ? ` — ${p.address.city}` : ""}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {loadingRooms ? (
//             <div className="rc-loading">Loading room categories...</div>
//           ) : rooms.length === 0 ? (
//             <div className="rc-empty">
//               <h3 style={{ margin: "0 0 6px", color: "#0f172a" }}>No room categories yet</h3>
//               <p style={{ margin: "0 0 16px" }}>Add the first room category for this palace.</p>
//               <button type="button" className="rc-btn rc-primary" onClick={openCreate}>
//                 + Add room category
//               </button>
//             </div>
//           ) : (
//             <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 14, overflowX: "auto" }}>
//               <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 760, fontSize: 13 }}>
//                 <thead>
//                   <tr style={{ background: "#f8fafc", textAlign: "left", color: "#475569" }}>
//                     { ["Room category", "Room type", "Beds / guests", "Total units", "Images", "Status", "Actions"].map((heading) => (
//                       <th key={heading} style={{ padding: "14px 12px", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" }}>{heading}</th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {rooms.map((room) => {
//                     const busy = busyId === room._id;
//                     const typeLabel = ROOM_TYPES.find(([id]) => id === room.roomType)?.[1] || room.roomType;
//                     return (
//                       <tr key={room._id}>
//                         <td style={{ padding: "12px", borderBottom: "1px solid #f1f5f9" }}>
//                           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//                             {room.coverImage?.url ? <img src={room.coverImage.url} alt="" style={{ width: 48, height: 42, borderRadius: 7, objectFit: "cover" }} /> : <div style={{ width: 48, height: 42, borderRadius: 7, background: "#f1f5f9", display: "grid", placeItems: "center", color: "#94a3b8" }}>—</div>}
//                             <div><strong>{room.name}</strong><div style={{ color: "#64748b", fontSize: 11 }}>{room.roomSize > 0 ? `${room.roomSize} ${room.roomSizeUnit === "SQM" ? "sq m" : "sq ft"}` : "Size not set"}</div></div>
//                           </div>
//                         </td>
//                         <td style={{ padding: "12px", borderBottom: "1px solid #f1f5f9" }}>{typeLabel}</td>
//                         <td style={{ padding: "12px", borderBottom: "1px solid #f1f5f9" }}>{room.bedCount} {room.bedType || "bed"}{room.bedCount > 1 ? "s" : ""}<div style={{ color: "#64748b", fontSize: 11 }}>Up to {room.maxGuests} guests</div></td>
//                         <td style={{ padding: "12px", borderBottom: "1px solid #f1f5f9", fontWeight: 700 }}>{room.totalUnits}</td>
//                         <td style={{ padding: "12px", borderBottom: "1px solid #f1f5f9" }}>{room.images?.length || 0}</td>
//                         <td style={{ padding: "12px", borderBottom: "1px solid #f1f5f9" }}><span style={{ display: "inline-block", padding: "4px 8px", borderRadius: 999, fontSize: 11, fontWeight: 700, color: room.isActive ? "#166534" : "#475569", background: room.isActive ? "#dcfce7" : "#f1f5f9" }}>{room.isActive ? "Active" : "Inactive"}</span></td>
//                         <td style={{ padding: "12px", borderBottom: "1px solid #f1f5f9" }}><div style={{ display: "flex", gap: 6 }}>
//                           <button type="button" className="rc-btn rc-ghost rc-small" onClick={() => openEdit(room)} disabled={busy}>Edit</button>
//                           <button type="button" className="rc-btn rc-ghost rc-small" onClick={() => handleToggle(room)} disabled={busy}>{busy ? "..." : room.isActive ? "Deactivate" : "Activate"}</button>
//                           <button type="button" className="rc-btn rc-danger rc-small" onClick={() => handleDelete(room)} disabled={busy}>Delete</button>
//                         </div></td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </>
//       )}
//     </div>
//   );
// }



// src/pages/PalaceRoomCategories.jsx

import { useCallback, useEffect, useRef, useState } from "react";

/* =====================================================
   API CONFIG
===================================================== */

const API_BASE =
  process.env.REACT_APP_API_URL || "https://bmtvendorvendorfinal.onrender.com";

const PALACE_API = `${API_BASE}/api/palaces`;
const ROOM_API = `${API_BASE}/api/palace-room-categories`;

const MAX_IMAGES = 15;
const MAX_IMAGE_MB = 10;

const ROOM_TYPES = [
  ["DELUXE", "Deluxe"],
  ["PREMIUM", "Premium"],
  ["ROYAL", "Royal"],
  ["HERITAGE", "Heritage"],
  ["SUITE", "Suite"],
  ["MAHARAJA_SUITE", "Maharaja Suite"],
  ["VILLA", "Villa"],
  ["OTHER", "Other"],
];

const AMENITIES = [
  "Air Conditioning",
  "Free Wi-Fi",
  "TV",
  "Mini Bar",
  "Tea / Coffee Maker",
  "Private Balcony",
  "Bathtub",
  "Attached Bathroom",
  "Safe / Locker",
  "Hair Dryer",
  "Work Desk",
  "Heating",
  "Garden View",
  "Palace View",
  "Pool View",
  "Room Service",
  "Butler Service",
];

const STEPS = [
  "Basic information",
  "Size & beds",
  "Guest capacity",
  "Amenities",
  "Images",
];

const EMPTY_FORM = {
  name: "",
  description: "",
  roomType: "DELUXE",
  roomSize: "0",
  roomSizeUnit: "SQFT",
  bedType: "",
  bedCount: "1",
  totalUnits: "1",
  includedAdults: "2",
  maxAdults: "2",
  maxChildren: "0",
  maxGuests: "2",
  extraMattressAllowed: false,
  maxExtraMattress: "0",
  amenities: [],
};

/* =====================================================
   API REQUEST
===================================================== */

async function request(url, options = {}) {
  const token = localStorage.getItem("vendorToken");

  if (!token) {
    window.location.href = "/vendor-login";
    throw new Error("Session expired. Please login again.");
  }

  const response = await fetch(url, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(options.headers || {}),
    },
  });

  const data = await response.json().catch(() => ({}));

  if (response.status === 401) {
    localStorage.removeItem("vendorToken");
    localStorage.removeItem("vendorUser");
    window.location.href = "/vendor-login";

    throw new Error("Session expired. Please login again.");
  }

  if (!response.ok || data.success === false) {
    throw new Error(
      data.message || `Request failed (${response.status})`
    );
  }

  return data;
}

/* =====================================================
   HELPERS
===================================================== */

function getList(response) {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response?.palaces)) return response.palaces;
  if (Array.isArray(response?.results)) return response.results;
  return [];
}

function getSavedRoom(response) {
  return response?.data?.room || response?.data || response?.room || response;
}

function toForm(room) {
  if (!room) return { ...EMPTY_FORM, amenities: [] };

  return {
    name: String(room.name ?? ""),
    description: String(room.description ?? ""),
    roomType: room.roomType || "DELUXE",
    roomSize: String(room.roomSize ?? 0),
    roomSizeUnit: room.roomSizeUnit || "SQFT",
    bedType: String(room.bedType ?? ""),
    bedCount: String(room.bedCount ?? 1),
    totalUnits: String(room.totalUnits ?? 1),
    includedAdults: String(room.includedAdults ?? 2),
    maxAdults: String(room.maxAdults ?? 2),
    maxChildren: String(room.maxChildren ?? 0),
    maxGuests: String(room.maxGuests ?? 2),
    extraMattressAllowed: Boolean(room.extraMattressAllowed),
    maxExtraMattress: String(room.maxExtraMattress ?? 0),
    amenities: Array.isArray(room.amenities)
      ? room.amenities
      : [],
  };
}

function validateForm(form) {
  if (!form.name.trim()) {
    return "Room category name is required.";
  }

  if (form.name.trim().length > 120) {
    return "Name cannot exceed 120 characters.";
  }

  if (!Number.isFinite(Number(form.roomSize)) || Number(form.roomSize) < 0) {
    return "Room size must be 0 or more.";
  }

  if (!Number.isInteger(Number(form.bedCount)) || Number(form.bedCount) < 1) {
    return "Bed count must be at least 1.";
  }

  if (!Number.isInteger(Number(form.totalUnits)) || Number(form.totalUnits) < 1) {
    return "Total units must be at least 1.";
  }

  const includedAdults = Number(form.includedAdults);
  const maxAdults = Number(form.maxAdults);
  const maxChildren = Number(form.maxChildren);
  const maxGuests = Number(form.maxGuests);
  const maxExtraMattress = Number(form.maxExtraMattress);

  if (!Number.isInteger(includedAdults) || includedAdults < 1) {
    return "Included adults must be at least 1.";
  }

  if (!Number.isInteger(maxAdults) || maxAdults < 1) {
    return "Max adults must be at least 1.";
  }

  if (!Number.isInteger(maxChildren) || maxChildren < 0) {
    return "Max children must be 0 or more.";
  }

  if (!Number.isInteger(maxGuests) || maxGuests < 1) {
    return "Max guests must be at least 1.";
  }

  if (!Number.isInteger(maxExtraMattress) || maxExtraMattress < 0) {
    return "Max extra mattress must be 0 or more.";
  }

  if (includedAdults > maxAdults) {
    return "Included adults cannot exceed max adults.";
  }

  if (maxGuests < includedAdults) {
    return "Max guests cannot be less than included adults.";
  }

  if (maxGuests < maxAdults + maxChildren) {
    return "Max guests must be at least max adults + max children.";
  }

  if (form.extraMattressAllowed && maxExtraMattress < 1) {
    return "Set max extra mattress to 1 or more.";
  }

  const normalizedAmenities = form.amenities.map((a) =>
    a.trim().toLowerCase()
  );

  if (
    normalizedAmenities.some((a) => !a) ||
    new Set(normalizedAmenities).size !== normalizedAmenities.length
  ) {
    return "Amenities cannot be empty or duplicated.";
  }

  return "";
}

/* =====================================================
   STYLES
===================================================== */

const css = `
.rc-wrap{font-family:Inter,'Segoe UI',Arial,sans-serif;color:#0f172a}
.rc-head{display:flex;justify-content:space-between;align-items:center;gap:16px;flex-wrap:wrap;margin-bottom:22px}
.rc-head h2{margin:0 0 5px;font-size:26px;letter-spacing:-.5px}
.rc-head p{margin:0;color:#64748b;font-size:14px}
.rc-btn{border:0;border-radius:9px;padding:10px 16px;font-size:13px;font-weight:700;cursor:pointer;transition:.2s}
.rc-btn:disabled{opacity:.55;cursor:not-allowed}
.rc-primary{background:#ea580c;color:white}
.rc-primary:hover:not(:disabled){background:#c2410c}
.rc-ghost{background:white;border:1px solid #cbd5e1;color:#0f172a}
.rc-danger{background:white;border:1px solid #fecaca;color:#b91c1c}
.rc-small{padding:7px 11px;font-size:12px}
.rc-alert{padding:12px 15px;border-radius:10px;margin-bottom:16px;font-size:13px}
.rc-err{background:#fff7ed;border:1px solid #fed7aa;color:#9a3412}
.rc-ok{background:#f0fdf4;border:1px solid #bbf7d0;color:#166534}
.rc-picker{display:flex;align-items:center;gap:12px;flex-wrap:wrap;background:white;border:1px solid #e2e8f0;border-radius:13px;padding:16px;margin-bottom:20px}
.rc-picker label{font-size:13px;font-weight:700}
.rc-picker select{flex:1;min-width:220px;border:1px solid #cbd5e1;border-radius:9px;padding:11px;background:white;color:#0f172a}
.rc-form{display:flex;flex-direction:column;gap:18px}
.rc-stepper{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:8px;background:white;border:1px solid #e2e8f0;border-radius:14px;padding:15px}
.rc-step{display:flex;align-items:center;gap:8px;color:#94a3b8;font-size:12px;min-width:0}
.rc-step span{display:grid;place-items:center;flex:0 0 29px;height:29px;border-radius:50%;background:#f1f5f9;font-weight:800}
.rc-step small{font-size:11px;line-height:1.3}
.rc-step.active{color:#c2410c;font-weight:800}
.rc-step.active span,.rc-step.done span{background:#ea580c;color:white}
.rc-step.done{color:#475569}
.rc-section{background:white;border:1px solid #e2e8f0;border-radius:14px;padding:22px}
.rc-section h3{margin:0 0 16px;font-size:17px}
.rc-fields{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:15px}
.rc-field{display:flex;flex-direction:column;gap:7px;min-width:0}
.rc-field.full{grid-column:1/-1}
.rc-field label{font-size:12px;font-weight:700;color:#374151}
.rc-field input,.rc-field select,.rc-field textarea{width:100%;box-sizing:border-box;border:1px solid #cbd5e1;border-radius:9px;padding:11px 12px;font-size:14px;font-family:inherit;color:#0f172a;background:white;outline:none}
.rc-field input:focus,.rc-field select:focus,.rc-field textarea:focus{border-color:#ea580c}
.rc-hint{font-size:11px;color:#64748b}
.rc-chips{display:flex;flex-wrap:wrap;gap:9px}
.rc-chip{display:inline-flex;align-items:center;gap:7px;padding:9px 12px;border:1px solid #cbd5e1;border-radius:9px;font-size:12px;cursor:pointer;background:white;user-select:none}
.rc-chip.on{background:#fff1e8;border-color:#ea580c;color:#c2410c;font-weight:700}
.rc-inline{display:flex;gap:8px;margin-top:16px}
.rc-inline input{flex:1;min-width:0;border:1px solid #cbd5e1;border-radius:9px;padding:10px}
.rc-drop{display:flex;align-items:center;gap:13px;padding:18px;border:1.5px dashed #cbd5e1;border-radius:12px;background:#f8fafc}
.rc-drop-icon{display:grid;place-items:center;width:42px;height:42px;border-radius:10px;background:#fff1e8;color:#ea580c;font-size:24px;font-weight:700}
.rc-drop small{display:block;color:#64748b;font-size:12px;margin-top:4px}
.rc-images{display:grid;grid-template-columns:repeat(auto-fill,minmax(145px,1fr));gap:12px;margin-top:16px}
.rc-img{position:relative;border:1px solid #e2e8f0;border-radius:11px;overflow:hidden;background:white}
.rc-img img{width:100%;height:125px;object-fit:cover;display:block}
.rc-img-bar{padding:8px}
.rc-tag{position:absolute;top:8px;left:8px;color:white;font-size:10px;font-weight:800;padding:4px 8px;border-radius:99px;background:#0f172a}
.rc-footer{display:flex;justify-content:space-between;gap:10px;position:sticky;bottom:0;background:#f8fafc;padding:14px 0;border-top:1px solid #e2e8f0;z-index:2}
.rc-footer-right{display:flex;gap:10px}
.rc-empty{background:white;border:1px dashed #cbd5e1;border-radius:14px;padding:45px 20px;text-align:center;color:#64748b}
.rc-table-wrap{overflow-x:auto;background:white;border:1px solid #e2e8f0;border-radius:14px}
.rc-table{width:100%;border-collapse:collapse;min-width:750px}
.rc-table th,.rc-table td{padding:14px;text-align:left;border-bottom:1px solid #e2e8f0;font-size:13px;vertical-align:middle}
.rc-table th{background:#f8fafc;color:#475569;font-size:11px;text-transform:uppercase;letter-spacing:.4px}
.rc-table tr:last-child td{border-bottom:0}
.rc-room-img{width:58px;height:48px;object-fit:cover;border-radius:7px;background:#f1f5f9}
.rc-status{display:inline-block;padding:5px 9px;border-radius:99px;font-size:11px;font-weight:700}
.rc-active{background:#dcfce7;color:#166534}
.rc-inactive{background:#f1f5f9;color:#475569}
.rc-actions{display:flex;gap:6px;flex-wrap:wrap}
.rc-loading{padding:35px;text-align:center;color:#64748b}
@media(max-width:700px){
.rc-fields{grid-template-columns:1fr}
.rc-stepper{grid-template-columns:1fr 1fr}
.rc-step small{font-size:10px}
.rc-section{padding:15px}
}
`;

/* =====================================================
   FIELD COMPONENT
===================================================== */

function Field({
  label,
  value,
  onChange,
  type = "text",
  placeholder = "",
  min,
  max,
  step,
  hint,
  full = false,
}) {
  return (
    <div className={`rc-field ${full ? "full" : ""}`}>
      <label>{label}</label>

      {type === "textarea" ? (
        <textarea
          rows={4}
          value={value}
          placeholder={placeholder}
          onChange={(event) => onChange(event.target.value)}
        />
      ) : (
        <input
          type={type}
          value={value}
          placeholder={placeholder}
          min={min}
          max={max}
          step={step}
          onChange={(event) => onChange(event.target.value)}
        />
      )}

      {hint && <div className="rc-hint">{hint}</div>}
    </div>
  );
}

/* =====================================================
   ROOM CATEGORY FORM
===================================================== */

function RoomForm({ palaceId, room, onCancel, onSaved }) {
  const isEdit = Boolean(room);

  const [form, setForm] = useState(() => toForm(room));
  const [step, setStep] = useState(0);
  const stepRef = useRef(0);

  const [newFiles, setNewFiles] = useState([]);
  const [customAmenity, setCustomAmenity] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const existingImages = Array.isArray(room?.images) ? room.images : [];

  const changeStep = (nextStep) => {
    const safeStep = Math.max(0, Math.min(4, nextStep));
    stepRef.current = safeStep;
    setStep(safeStep);
    setError("");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    return () => {
      newFiles.forEach((item) => URL.revokeObjectURL(item.preview));
    };
    // Component cleanup only.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setField = (name, value) => {
    setForm((previous) => ({ ...previous, [name]: value }));
    setError("");
  };

  const toggleAmenity = (name) => {
    setForm((previous) => ({
      ...previous,
      amenities: previous.amenities.includes(name)
        ? previous.amenities.filter((item) => item !== name)
        : [...previous.amenities, name],
    }));
    setError("");
  };

  const addCustomAmenity = () => {
    const value = customAmenity.trim();

    if (!value) return;

    if (
      form.amenities.some(
        (item) => item.toLowerCase() === value.toLowerCase()
      )
    ) {
      setError("This amenity has already been added.");
      return;
    }

    setForm((previous) => ({
      ...previous,
      amenities: [...previous.amenities, value],
    }));

    setCustomAmenity("");
    setError("");
  };

  const pickFiles = (event) => {
    const selectedFiles = Array.from(event.target.files || []);
    event.target.value = "";

    const picked = [];
    let problem = "";

    selectedFiles.forEach((file) => {
      if (!file.type.startsWith("image/")) {
        problem = `${file.name} is not an image.`;
        return;
      }

      if (file.size > MAX_IMAGE_MB * 1024 * 1024) {
        problem = `${file.name} exceeds ${MAX_IMAGE_MB} MB.`;
        return;
      }

      picked.push({
        file,
        preview: URL.createObjectURL(file),
      });
    });

    if (existingImages.length + newFiles.length + picked.length > MAX_IMAGES) {
      picked.forEach((item) => URL.revokeObjectURL(item.preview));
      setError(`You can upload a maximum of ${MAX_IMAGES} images.`);
      return;
    }

    setNewFiles((previous) => [...previous, ...picked]);
    setError(problem);
  };

  const removeNewFile = (index) => {
    setNewFiles((previous) => {
      const item = previous[index];

      if (item) URL.revokeObjectURL(item.preview);

      return previous.filter((_, currentIndex) => currentIndex !== index);
    });
  };

  /* =====================================================
     NEXT BUTTON
     This function ONLY changes the step.
     It NEVER calls the save API.
  ===================================================== */

  const handleNext = () => {
    const currentStep = stepRef.current;
    setError("");

    if (currentStep === 0) {
      if (!form.name.trim()) {
        setError("Room category name is required.");
        return;
      }

      if (
        !Number.isInteger(Number(form.totalUnits)) ||
        Number(form.totalUnits) < 1
      ) {
        setError("Total units must be a whole number, at least 1.");
        return;
      }
    }

    if (currentStep === 1) {
      if (!Number.isFinite(Number(form.roomSize)) || Number(form.roomSize) < 0) {
        setError("Room size must be 0 or more.");
        return;
      }

      if (
        !Number.isInteger(Number(form.bedCount)) ||
        Number(form.bedCount) < 1
      ) {
        setError("Bed count must be at least 1.");
        return;
      }

      if (!form.bedType.trim()) {
        setError("Please enter a bed type.");
        return;
      }
    }

    if (currentStep === 2) {
      const validationError = validateForm(form);

      if (validationError) {
        setError(validationError);
        return;
      }
    }

    // Amenities step = 3; Images step = 4.
    // Do not submit or save here.
    changeStep(currentStep + 1);
  };

  /* =====================================================
     SAVE
     Only permitted on Images step (step 4).
  ===================================================== */

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    // Read the ref so an early/stale submit cannot save.
    if (stepRef.current !== 4) {
      console.warn(
        "Room category save blocked. Images step has not been reached."
      );
      return;
    }

    if (saving) return;

    const validationError = validateForm(form);

    if (validationError) {
      setError(validationError);
      return;
    }

    if (!isEdit && !palaceId) {
      setError("Please select a Palace first.");
      return;
    }

    // For new categories, require at least one selected image.
    if (!isEdit && newFiles.length === 0) {
      setError("Please select at least one room image before saving.");
      return;
    }

    const body = new FormData();

    if (!isEdit) {
      body.append("palaceId", palaceId);
    }

    body.append("name", form.name.trim());
    body.append("description", form.description);
    body.append("roomType", form.roomType);
    body.append("roomSize", form.roomSize || "0");
    body.append("roomSizeUnit", form.roomSizeUnit);
    body.append("bedType", form.bedType.trim());
    body.append("bedCount", form.bedCount);
    body.append("totalUnits", form.totalUnits);
    body.append("includedAdults", form.includedAdults);
    body.append("maxAdults", form.maxAdults);
    body.append("maxChildren", form.maxChildren);
    body.append("maxGuests", form.maxGuests);

    body.append(
      "extraMattressAllowed",
      String(form.extraMattressAllowed)
    );

    body.append(
      "maxExtraMattress",
      form.extraMattressAllowed ? form.maxExtraMattress : "0"
    );

    body.append("amenities", JSON.stringify(form.amenities));

    newFiles.forEach((item) => {
      body.append("images", item.file);
    });

    setSaving(true);
    setError("");

    try {
      const response = await request(
        isEdit ? `${ROOM_API}/${room._id}` : ROOM_API,
        {
          method: isEdit ? "PUT" : "POST",
          body,
        }
      );

      const savedRoom = getSavedRoom(response);

      if (!savedRoom?._id) {
        throw new Error(
          "The server response did not include the saved room category."
        );
      }

      onSaved(
        savedRoom,
        isEdit
          ? "Room category updated successfully."
          : "Room category created successfully."
      );
    } catch (err) {
      setError(err.message || "Unable to save room category.");
      window.scrollTo({ top: 0, behavior: "smooth" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <form
      className="rc-form"
      onSubmit={handleSubmit}
      noValidate
    >
      <div className="rc-stepper">
        {STEPS.map((label, index) => (
          <div
            key={label}
            className={`rc-step ${
              index === step ? "active" : ""
            } ${index < step ? "done" : ""}`}
          >
            <span>{index < step ? "✓" : index + 1}</span>
            <small>{label}</small>
          </div>
        ))}
      </div>

      {error && <div className="rc-alert rc-err">{error}</div>}

      {/* STEP 1: BASIC INFORMATION */}

      {step === 0 && (
        <section className="rc-section">
          <h3>Basic information</h3>

          <div className="rc-fields">
            <Field
              label="Room category name *"
              value={form.name}
              onChange={(value) => setField("name", value)}
              placeholder="e.g. Royal Heritage Suite"
              full
            />

            <div className="rc-field">
              <label>Room type *</label>
              <select
                value={form.roomType}
                onChange={(event) =>
                  setField("roomType", event.target.value)
                }
              >
                {ROOM_TYPES.map(([value, label]) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </select>
            </div>

            <Field
              label="Total units *"
              type="number"
              min="1"
              value={form.totalUnits}
              onChange={(value) => setField("totalUnits", value)}
              hint="Number of rooms available in this category."
            />

            <Field
              label="Description"
              type="textarea"
              value={form.description}
              onChange={(value) => setField("description", value)}
              placeholder="Describe this room category..."
              full
            />
          </div>
        </section>
      )}

      {/* STEP 2: SIZE & BEDS */}

      {step === 1 && (
        <section className="rc-section">
          <h3>Room size and beds</h3>

          <div className="rc-fields">
            <Field
              label="Room size *"
              type="number"
              min="0"
              value={form.roomSize}
              onChange={(value) => setField("roomSize", value)}
            />

            <div className="rc-field">
              <label>Room size unit</label>
              <select
                value={form.roomSizeUnit}
                onChange={(event) =>
                  setField("roomSizeUnit", event.target.value)
                }
              >
                <option value="SQFT">Square feet (sq ft)</option>
                <option value="SQM">Square metres (sq m)</option>
              </select>
            </div>

            <Field
              label="Bed type *"
              value={form.bedType}
              onChange={(value) => setField("bedType", value)}
              placeholder="King, Queen, Twin, etc."
            />

            <Field
              label="Number of beds *"
              type="number"
              min="1"
              value={form.bedCount}
              onChange={(value) => setField("bedCount", value)}
            />
          </div>
        </section>
      )}

      {/* STEP 3: GUEST CAPACITY */}

      {step === 2 && (
        <section className="rc-section">
          <h3>Guest capacity</h3>

          <div className="rc-fields">
            <Field
              label="Included adults *"
              type="number"
              min="1"
              value={form.includedAdults}
              onChange={(value) => setField("includedAdults", value)}
            />

            <Field
              label="Maximum adults *"
              type="number"
              min="1"
              value={form.maxAdults}
              onChange={(value) => setField("maxAdults", value)}
            />

            <Field
              label="Maximum children *"
              type="number"
              min="0"
              value={form.maxChildren}
              onChange={(value) => setField("maxChildren", value)}
            />

            <Field
              label="Maximum guests *"
              type="number"
              min="1"
              value={form.maxGuests}
              onChange={(value) => setField("maxGuests", value)}
              hint="Must be at least max adults + max children."
            />
          </div>

          <div style={{ marginTop: 18 }}>
            <label className="rc-chip">
              <input
                type="checkbox"
                checked={form.extraMattressAllowed}
                onChange={(event) =>
                  setField("extraMattressAllowed", event.target.checked)
                }
              />
              Allow extra mattress
            </label>
          </div>

          {form.extraMattressAllowed && (
            <div className="rc-fields" style={{ marginTop: 15 }}>
              <Field
                label="Maximum extra mattresses"
                type="number"
                min="1"
                value={form.maxExtraMattress}
                onChange={(value) =>
                  setField("maxExtraMattress", value)
                }
              />
            </div>
          )}
        </section>
      )}

      {/* STEP 4: AMENITIES */}

      {step === 3 && (
        <section className="rc-section">
          <h3>Room amenities</h3>

          <div className="rc-chips">
            {AMENITIES.map((amenity) => {
              const selected = form.amenities.includes(amenity);

              return (
                <label
                  key={amenity}
                  className={`rc-chip ${selected ? "on" : ""}`}
                >
                  <input
                    type="checkbox"
                    checked={selected}
                    onChange={() => toggleAmenity(amenity)}
                  />
                  {selected ? "✓ " : ""}
                  {amenity}
                </label>
              );
            })}

            {form.amenities
              .filter((amenity) => !AMENITIES.includes(amenity))
              .map((amenity) => (
                <label key={amenity} className="rc-chip on">
                  <input
                    type="checkbox"
                    checked
                    onChange={() => toggleAmenity(amenity)}
                  />
                  ✓ {amenity}
                </label>
              ))}
          </div>

          <div className="rc-inline">
            <input
              value={customAmenity}
              maxLength={100}
              placeholder="Add a custom amenity"
              onChange={(event) => setCustomAmenity(event.target.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  event.preventDefault();
                  addCustomAmenity();
                }
              }}
            />

            <button
              type="button"
              className="rc-btn rc-ghost"
              onClick={addCustomAmenity}
            >
              Add
            </button>
          </div>
        </section>
      )}

      {/* STEP 5: IMAGES */}

      {step === 4 && (
        <section className="rc-section">
          <h3>
            Upload room images ({existingImages.length + newFiles.length}/
            {MAX_IMAGES})
          </h3>

          <div className="rc-drop">
            <span className="rc-drop-icon">+</span>

            <div style={{ flex: 1 }}>
              <strong>Choose room images</strong>
              <small>
                JPG, PNG, WEBP or GIF · Maximum {MAX_IMAGE_MB} MB each
              </small>
            </div>

            <label
              htmlFor="rc-room-image-input"
              className="rc-btn rc-primary"
            >
              Choose images
            </label>

            <input
              id="rc-room-image-input"
              type="file"
              accept="image/jpeg,image/png,image/webp,image/gif"
              multiple
              onChange={pickFiles}
              disabled={
                existingImages.length + newFiles.length >= MAX_IMAGES
              }
              style={{ display: "none" }}
            />
          </div>

          {isEdit && existingImages.length > 0 && (
            <div className="rc-images">
              {existingImages.map((image, index) => (
                <div
                  className="rc-img"
                  key={image.publicId || image.url || index}
                >
                  {image.url ? (
                    <img src={image.url} alt="Existing room" />
                  ) : (
                    <div style={{ padding: 20 }}>Image unavailable</div>
                  )}

                  <span className="rc-tag">EXISTING</span>
                </div>
              ))}
            </div>
          )}

          {newFiles.length > 0 && (
            <div className="rc-images">
              {newFiles.map((item, index) => (
                <div
                  className="rc-img"
                  key={`${item.file.name}-${index}`}
                >
                  <img src={item.preview} alt={item.file.name} />

                  <span className="rc-tag">NEW</span>

                  <div className="rc-img-bar">
                    <button
                      type="button"
                      className="rc-btn rc-danger rc-small"
                      onClick={() => removeNewFile(index)}
                      disabled={saving}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {newFiles.length === 0 && existingImages.length === 0 && (
            <p className="rc-hint" style={{ marginTop: 15 }}>
              Please select at least one image before creating the room category.
            </p>
          )}

          {isEdit && existingImages.length > 0 && newFiles.length === 0 && (
            <p className="rc-hint" style={{ marginTop: 15 }}>
              Existing images will remain. You can add more images above.
            </p>
          )}
        </section>
      )}

      {/* FOOTER
          Next = type button, never submits the form.
          Submit button exists ONLY on step 4.
      */}

      <div className="rc-footer">
        <button
          type="button"
          className="rc-btn rc-ghost"
          disabled={saving}
          onClick={() => {
            if (stepRef.current === 0) {
              onCancel();
            } else {
              changeStep(stepRef.current - 1);
            }
          }}
        >
          {step === 0 ? "Cancel" : "← Back"}
        </button>

        <div className="rc-footer-right">
          {step < 4 ? (
            <button
              key="next-button"
              type="button"
              className="rc-btn rc-primary"
              disabled={saving}
              onClick={handleNext}
            >
              Next →
            </button>
          ) : (
            <button
              key="save-button"
              type="submit"
              className="rc-btn rc-primary"
              disabled={saving}
            >
              {saving
                ? "Uploading & saving..."
                : isEdit
                ? "Save changes"
                : "Create room category"}
            </button>
          )}
        </div>
      </div>
    </form>
  );
}

/* =====================================================
   MAIN PAGE
===================================================== */

export default function PalaceRoomCategories() {
  const [palaces, setPalaces] = useState([]);
  const [palaceId, setPalaceId] = useState("");
  const [rooms, setRooms] = useState([]);

  const [loadingPalaces, setLoadingPalaces] = useState(true);
  const [loadingRooms, setLoadingRooms] = useState(false);

  const [view, setView] = useState("list");
  const [editing, setEditing] = useState(null);

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [busyId, setBusyId] = useState("");

  useEffect(() => {
    let cancelled = false;

    async function loadPalaces() {
      try {
        const response = await request(PALACE_API);
        if (cancelled) return;

        const list = getList(response);
        setPalaces(list);

        const savedId = localStorage.getItem("selectedPalaceId");
        const selected = list.find((palace) => palace._id === savedId);
        const nextId = selected?._id || list[0]?._id || "";

        setPalaceId(nextId);

        if (nextId) {
          localStorage.setItem("selectedPalaceId", nextId);
        }
      } catch (err) {
        if (!cancelled) setError(err.message);
      } finally {
        if (!cancelled) setLoadingPalaces(false);
      }
    }

    loadPalaces();

    return () => {
      cancelled = true;
    };
  }, []);

  const loadRooms = useCallback(async (id) => {
    if (!id) {
      setRooms([]);
      return;
    }

    setLoadingRooms(true);

    try {
      const response = await request(`${ROOM_API}/palace/${id}`);
      setRooms(getList(response));
    } catch (err) {
      setError(err.message);
      setRooms([]);
    } finally {
      setLoadingRooms(false);
    }
  }, []);

  useEffect(() => {
    loadRooms(palaceId);
  }, [palaceId, loadRooms]);

  const selectPalace = (id) => {
    setPalaceId(id);
    localStorage.setItem("selectedPalaceId", id);
    setError("");
    setSuccess("");
  };

  const openCreate = () => {
    setEditing(null);
    setError("");
    setSuccess("");
    setView("form");
  };

  const openEdit = (room) => {
    setEditing(room);
    setError("");
    setSuccess("");
    setView("form");
  };

  const closeForm = () => {
    setView("list");
    setEditing(null);
    setError("");
  };

  const handleSaved = (savedRoom, message) => {
    setRooms((previous) =>
      previous.some((item) => item._id === savedRoom._id)
        ? previous.map((item) =>
            item._id === savedRoom._id ? savedRoom : item
          )
        : [savedRoom, ...previous]
    );

    setSuccess(message);
    setError("");
    setView("list");
    setEditing(null);

    loadRooms(palaceId);
  };

  const handleToggle = async (room) => {
    setBusyId(room._id);
    setError("");
    setSuccess("");

    try {
      const response = await request(
        `${ROOM_API}/${room._id}/toggle`,
        { method: "PATCH" }
      );

      const updated = getSavedRoom(response);

      setRooms((previous) =>
        previous.map((item) =>
          item._id === room._id ? updated : item
        )
      );

      setSuccess(response.message || "Room status updated.");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusyId("");
    }
  };

  const handleDelete = async (room) => {
    const confirmed = window.confirm(
      `Delete "${room.name}" and its images? This cannot be undone.`
    );

    if (!confirmed) return;

    setBusyId(room._id);
    setError("");
    setSuccess("");

    try {
      const response = await request(`${ROOM_API}/${room._id}`, {
        method: "DELETE",
      });

      setRooms((previous) =>
        previous.filter((item) => item._id !== room._id)
      );

      setSuccess(response.message || "Room category deleted.");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusyId("");
    }
  };

  const selectedPalace = palaces.find(
    (palace) => palace._id === palaceId
  );

  return (
    <div className="rc-wrap">
      <style>{css}</style>

      {view === "form" ? (
        <>
          <div className="rc-head">
            <div>
              <h2>{editing ? "Edit room category" : "Add room category"}</h2>
              <p>
                {editing
                  ? `Update ${editing.name}.`
                  : `Create a room category for ${
                      selectedPalace?.propertyName || "your palace"
                    }.`}
              </p>
            </div>
          </div>

          <div className="rc-picker">
            <label htmlFor="rc-form-palace">Palace</label>

            <select
              id="rc-form-palace"
              value={palaceId}
              onChange={(event) => selectPalace(event.target.value)}
              disabled={Boolean(editing)}
            >
              {palaces.map((palace) => (
                <option key={palace._id} value={palace._id}>
                  {palace.propertyName || palace.name || "Palace"}
                  {palace.address?.city
                    ? ` — ${palace.address.city}`
                    : ""}
                </option>
              ))}
            </select>
          </div>

          <RoomForm
            key={editing?._id || `new-${palaceId}`}
            palaceId={palaceId}
            room={editing}
            onCancel={closeForm}
            onSaved={handleSaved}
          />
        </>
      ) : (
        <>
          <div className="rc-head">
            <div>
              <h2>Palace room categories</h2>
              <p>
                Manage room types, guest capacity, amenities and images.
              </p>
            </div>

            <button
              type="button"
              className="rc-btn rc-primary"
              onClick={openCreate}
              disabled={!palaceId}
            >
              + Add room category
            </button>
          </div>

          {error && <div className="rc-alert rc-err">{error}</div>}
          {success && <div className="rc-alert rc-ok">{success}</div>}

          {loadingPalaces ? (
            <div className="rc-loading">Loading palaces...</div>
          ) : palaces.length === 0 ? (
            <div className="rc-empty">
              <h3>No palace found</h3>
              <p>Add a palace first, then create its room categories.</p>
            </div>
          ) : (
            <>
              <div className="rc-picker">
                <label htmlFor="rc-palace-select">Select palace</label>

                <select
                  id="rc-palace-select"
                  value={palaceId}
                  onChange={(event) => selectPalace(event.target.value)}
                >
                  {palaces.map((palace) => (
                    <option key={palace._id} value={palace._id}>
                      {palace.propertyName || palace.name || "Palace"}
                      {palace.address?.city
                        ? ` — ${palace.address.city}`
                        : ""}
                    </option>
                  ))}
                </select>
              </div>

              {loadingRooms ? (
                <div className="rc-loading">
                  Loading room categories...
                </div>
              ) : rooms.length === 0 ? (
                <div className="rc-empty">
                  <h3>No room categories yet</h3>
                  <p>Create the first room category for this palace.</p>

                  <button
                    type="button"
                    className="rc-btn rc-primary"
                    onClick={openCreate}
                  >
                    + Add room category
                  </button>
                </div>
              ) : (
                <div className="rc-table-wrap">
                  <table className="rc-table">
                    <thead>
                      <tr>
                        <th>Image</th>
                        <th>Room category</th>
                        <th>Room type</th>
                        <th>Size</th>
                        <th>Beds</th>
                        <th>Guests</th>
                        <th>Units</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>

                    <tbody>
                      {rooms.map((room) => {
                        const typeLabel =
                          ROOM_TYPES.find(
                            ([value]) => value === room.roomType
                          )?.[1] || room.roomType || "—";

                        const busy = busyId === room._id;

                        return (
                          <tr key={room._id}>
                            <td>
                              {room.coverImage?.url ? (
                                <img
                                  className="rc-room-img"
                                  src={room.coverImage.url}
                                  alt={room.name}
                                />
                              ) : room.images?.[0]?.url ? (
                                <img
                                  className="rc-room-img"
                                  src={room.images[0].url}
                                  alt={room.name}
                                />
                              ) : (
                                <div className="rc-room-img" />
                              )}
                            </td>

                            <td>
                              <strong>{room.name}</strong>
                              <div className="rc-hint">
                                {room.images?.length || 0} images
                              </div>
                            </td>

                            <td>{typeLabel}</td>

                            <td>
                              {room.roomSize ?? 0}{" "}
                              {room.roomSizeUnit === "SQM" ? "sq m" : "sq ft"}
                            </td>

                            <td>
                              {room.bedCount || 1}{" "}
                              {room.bedType || "bed"}
                            </td>

                            <td>{room.maxGuests ?? "—"}</td>

                            <td>{room.totalUnits ?? "—"}</td>

                            <td>
                              <span
                                className={`rc-status ${
                                  room.isActive ? "rc-active" : "rc-inactive"
                                }`}
                              >
                                {room.isActive ? "Active" : "Inactive"}
                              </span>
                            </td>

                            <td>
                              <div className="rc-actions">
                                <button
                                  type="button"
                                  className="rc-btn rc-ghost rc-small"
                                  onClick={() => openEdit(room)}
                                  disabled={busy}
                                >
                                  Edit
                                </button>

                                <button
                                  type="button"
                                  className="rc-btn rc-ghost rc-small"
                                  onClick={() => handleToggle(room)}
                                  disabled={busy}
                                >
                                  {busy
                                    ? "..."
                                    : room.isActive
                                    ? "Deactivate"
                                    : "Activate"}
                                </button>

                                <button
                                  type="button"
                                  className="rc-btn rc-danger rc-small"
                                  onClick={() => handleDelete(room)}
                                  disabled={busy}
                                >
                                  Delete
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
}